<app-nav-menu></app-nav-menu>
<p-toast></p-toast>
@if (airarabialoader) {
  <div style="width: 100%; height: 105vh; position: fixed; background:#000000e8; z-index: 500; margin-top: -70px; ">
    <div class="loaderforPassenger">
      Loading
      <span class="loadspan"></span>
    </div>
  </div>
}
@if (userService.showSpinner|async) {
  <div style="width: 100%; height: 105vh; position: fixed; background:#000000e8; z-index: 500; margin-top: -70px; ">
    <div class="loaderforPassenger_forBooking">
      <span class="message">Booking In Process</span>
      <span class="loadspan"></span>
    </div>
  </div>
}

@if (timeLeft<=120) {
  <p-dialog header="Booking Timer" [style]="{width: '30vw'}" [draggable]="false" [resizable]="false" [dismissableMask]="true" [(visible)]="timerbookingpop" [modal]="true">
    <div style="display:flex;justify-content:center;align-items:center;width:100%;flex-direction:column">
      <p>Your Fare is about to Expire in <strong>{{ minutesUnits }} : {{ secondsTens }}{{ secondsUnits }}</strong> Minutes.</p>
      <p>Please complete the Booking.</p>
    </div>
    <div style="display: flex; justify-content: center; align-items: center; width: 100%; padding-top: 7px;">
      <button (click)="timebookingclose()" class="button-68">Ok</button>
    </div>
  </p-dialog>
}
<main class="col-sm-12 main container">

  <div>
    <ng-template #issueticket let-modal>

      <div class="modal-success ">
        <img class="sucesspopup" src="assets/img/icons8-error.gif" />

        <p class="textpopupsuccess"> Are You Sure?</p>
        <p class="innerhtmlofmodal"> You Want To Issue Ticket?</p>
        <div class="marginbtnlft">
          <div>
            <button class="yesButton" [disabled]="buttonagreed" (click)="onSubmit()">Yes, issue it!</button>
          </div>
          <div>
            <button class="noButton" (click)="modal.dismiss()">No</button>
          </div>
        </div>
      </div>


    </ng-template>
  </div>
  <div>
    <ng-template #sweet let-modal>

      <div class="modal-success">
        <img class="sucesspopup" src="assets/img/newsuccess.gif" />

        <h2 class="textpopupsuccess"> Passenger Data Saved!</h2>
        <button class="okButton" (click)="modal.dismiss()">Ok</button>
      </div>


    </ng-template>
  </div>

  <!--bad-->
  <div>
    <ng-template #bad let-modal>

      <div class="modal-success">
        <img class="sucesspopup" src="assets/img/badicon.gif" />

        <h2 class="textpopupbad"> Not Saved!</h2>
        <h5 class="textsubheadpopup"> Please Try Again!</h5>
        <button class="okButton" (click)="modal.dismiss()">Ok</button>

      </div>


    </ng-template>
  </div>

  <div class="header-bg">
    <div class="d-flex">

      <div class="address_logo col-sm-2">
        @if (bookingBaseData.flightProp.tripType != 'multi') {
          <img class="flight_logo_main" src="assets/img/{{bookingBaseData.flightscheduleNew.departureFlight.airlineLogo}}" alt="airline logo" />
        }
        @if (bookingBaseData.flightProp.tripType == 'multi') {
          <img class="flight_logo_main" src="assets/img/{{bookingBaseData.flightscheduleNew.multiFlights[0].airlineLogo}}" alt="airline logo" />
        }
      </div>
      <div class="main_head col-sm-10">
        @for (item of bookingBaseData.airSegment; track item) {
          <div class="for_detail d-flex">
            <div class="for_head">{{item.origin.code}}</div>
            <i class="uil uil-arrow-right for_head-icon"></i>
            <div class="for_head">{{item.destination.code}}</div>
          </div>
        }
        <div class="icon_head">
          <i class="uil uil-angle-right-b "></i>
        </div>
        <!--<div class="trip_review">-->
        <a (click)="open(mymodal)" style="cursor:pointer;text-decoration:underline" class="trip_review">Review Your Trip</a>
      <!--</div>-->
    </div>

  </div>
  <div class="change_link">
    <a (click)="back()" class="change_class-link">Back To Search Result</a>
  </div>
</div>

<div class="content_container">

  <div class="col-sm-3 right_side right_side_container">
    <!--<div class="noti col-sm-12 price_summary">

    <h4 style="margin-bottom:35px">Price Summary</h4>

    <div *ngFor="let price of priceCardDetails">
      <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Traveler: {{price.passengerType}}</label></div>

      <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Base Price</label><span>{{price.indivisualBasePrice}}</span></div>

      <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Taxes & Other charges</label><span>{{price.indivisualTaxes}}</span></div>

      <hr style="margin-top:20px" />
    </div>
    <div class="d-flex justify-content-between align-items-center price_summary_children"><label class="price_total_label">Total Base Price</label><span class="price_total_tag">{{bookingBaseData.airPricingSolution.basePrice}}</span></div>
    <div class="d-flex justify-content-between align-items-center price_summary_children"><label class="price_total_label">Total Taxes</label><span class="price_total_tag">{{bookingBaseData.airPricingSolution.taxes}}</span></div>
    <div class="d-flex justify-content-between align-items-center price_summary_children"><label class="price_total_label" style="font-weight: 800;font-size:16px">Trip Total</label><span class="price_total_tag" style="font-weight:800;font-size:16px">{{bookingBaseData.airPricingSolution.totalPrice}}</span></div>

  </div>-->
  <div class="passenger-timer-section">
    <div class="timer-mobile-label d-md-none">
      <i class="fas fa-clock timer-clock-icon"></i>
      <span class="timer-mobile-text">Time left:</span>
    </div>
    <div class="timer-digits-wrapper">
      <div class="boxTimer" [style.backgroundColor]="timeLeft <= 300 ? '#f83b35' : '#58c870'">{{ minutesTens }}</div>
      <div class="boxTimer" [style.backgroundColor]="timeLeft <= 300 ? '#f83b35' : '#58c870'">{{ minutesUnits }}</div>
      <div class="boxColon" [style.backgroundColor]="timeLeft <= 300 ? '#f83b35' : '#58c870'">:</div>
      <div class="boxTimer" [style.backgroundColor]="timeLeft <= 300 ? '#f83b35' : '#58c870'">{{ secondsTens }}</div>
      <div class="boxTimer" [style.backgroundColor]="timeLeft <= 300 ? '#f83b35' : '#58c870'">{{ secondsUnits }}</div>
    </div>
  </div>

  <!-- Mobile Summary Toggle Divider -->
  <div class="mobile-summary-toggle-bar col-12 d-xl-none d-lg-none">
    <button type="button" class="mobile-summary-toggle-btn" (click)="mobileSummaryOpen = !mobileSummaryOpen">
      <i class="fas fa-file-invoice-dollar"></i>
      <span>Flight &amp; Fare Summary</span>
      @if (totalPriceConv) {
        <span class="mobile-summary-price">{{ totalPriceConv }}</span>
      }
      <i class="fas" [ngClass]="mobileSummaryOpen ? 'fa-minus' : 'fa-plus'" style="margin-left: auto;"></i>
    </button>
  </div>

  <div class="passenger-summary-content" [ngClass]="{'mobile-summary-collapsed': !mobileSummaryOpen}">
    <div class="passenger-supplier-header" style="display: flex; display: flex; justify-content: center; align-items: center; background-color: #c0c0c04a; border-radius: 5px; padding: 5px; margin-bottom: 8px;">
      <h2 style="color:black;font-weight:bold;letter-spacing:2px;">{{bookingBaseData.supplierCode}}</h2>
    </div>
    <div class="noti col-sm-12 price_summary">
    @if (showServiceCharges) {
      <div class="row m-0 p-1" style="width: 100%; display: flex; justify-content: center; align-items: center; ">
        <!--<div style="width:100%;display:flex">
        <div style="width:80%">
          <label style="color:black;font-size:12px;font-weight:bold">Service Charges Per Passenger</label>
          <input type="number" [(ngModel)]="serviceChargesPNR" style="padding: 5px; border: 1px solid var(--first-color-second); border-top-left-radius: 4px; border-bottom-left-radius: 4px; color: black; width: 100%; " />
        </div>
        <div style="width: 20%; margin-top: 17px; padding: 5px;">
          <button style="padding: 3px; border-radius: 3px;" class="applybutton" (click)="ApplyServiceCharges()">Apply</button>
        </div>
      </div>-->
      <label style="color:black;font-size:12px;font-weight:bold">Service Charges Per Passenger</label>
      <div class="searchbox-wrap">
        <input type="number" placeholder="Markup" [(ngModel)]="serviceChargesPNR">
        <button (click)="ApplyServiceCharges()"><span>Apply</span> </button>
      </div>
      <div class="due-date">
        <label class="due-description" for="due">Due Date:</label>
        <input type="date" class="datestyle" id="due" placeholder="Due Date" [(ngModel)]="dueDate">
        <!--<button (click)="ApplyServiceCharges()"><span>Apply</span> </button>-->
      </div>
    </div>
  }
</div>
@if (selectedBrandBaggage && selectedBrandBaggage.length > 0) {
  <div class="noti col-sm-12 price_summary">
    <div class="">
      <h4 style="color: var(--first-color-second); font-size:14px;">Baggage Details</h4>
    </div>
    <table class="baggage-table" style="font-size:12px">
      <thead>
        <tr>
          <th>Passenger Type</th>
          <th>Sector</th>
          <th>Cabin Baggage</th>
          <th>Check-in Baggage</th>
        </tr>
      </thead>
      <tbody>
        @for (item of selectedBrandBaggage; track item) {
          <tr>
            <td>{{ item.passengerType }}</td>
            <td>{{ item.sector }}</td>
            <td>{{ item.cabinBaggage }}</td>
            <td>{{ item.checkinBaggage }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}

<div class="noti col-sm-12 price_summary">

  <h4 style="margin-bottom:20px">
    Price Summary
  </h4>

  <!--<div *ngFor="let price of priceCardDetails">
  <div class="d-flex justify-content-between align-items-center price_summary_children_type"><label>{{price.passengerType}} <span *ngIf="price.passengerCount > 1">x {{price.passengerCount}}</span></label></div>

  <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Base Price</label><span>{{price.indivisualBasePrice}}</span></div>

  <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Taxes & Other charges</label><span>{{price.indivisualTaxes}}</span></div>
  <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Service Fee</label><span>{{price.serviceFee}}</span></div>
  <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Discount</label><span>{{price.discount}}</span></div>
  <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Seat Fee</label><span>{{price.seatFee}}</span></div>
  <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Meal Fee</label><span>{{price.mealFee}}</span></div>
  <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Baggage Fee</label><span>{{price.baggageFee}}</span></div>
  <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Total Price</label><span>{{price.indivisualTotalPrice}}</span></div>

  <hr style="margin-top:20px" />
</div>-->
@for (price of priceCardDetails; track price) {
  <div>
    <div class="d-flex justify-content-between align-items-center price_summary_children_type"><label>{{price.passengerType}} @if (price.passengerCount > 1) {
      <span>x {{price.passengerCount}}</span>
    }</label></div>
    <!--<div class="d-flex justify-content-between align-items-center price_summary_children"><label>Base Price</label><span>{{price.indivisualBasePrice}}</span></div>-->
    <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Base Price</label><span>{{price.agencyBasePrice}}</span></div>
    <!--<div class="d-flex justify-content-between align-items-center price_summary_children"><label>Taxes & Other charges</label><span>{{price.indivisualTaxes}}</span></div>-->
    <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Taxes & Other charges</label><span>{{price.agencyTaxes}}</span></div>
    <!--<div class="d-flex justify-content-between align-items-center price_summary_children"><label>Service Fee</label><span>{{price.serviceFee}}</span></div>-->
    <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Service Fee</label><span>{{price.agencyServiceFee}}</span></div>
    <!--<div class="d-flex justify-content-between align-items-center price_summary_children"><label>Discount</label><span>{{price.discount}}</span></div>-->
    <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Discount</label><span>{{price.agencyDiscount}}</span></div>
    <!--<div class="d-flex justify-content-between align-items-center price_summary_children"><label>Total Price</label><span>{{price.indivisualTotalPrice}}</span></div>-->
    <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Seat Fee</label><span>{{price.seatFee}}</span></div>
    <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Meal Fee</label><span>{{price.mealFee}}</span></div>
    <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Baggage Fee</label><span>{{price.baggageFee}}</span></div>
    <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Total Price</label><span>{{price.agencyTotalPrice}}</span></div>
    <hr style="margin-top:20px" />
  </div>
}
<div class="d-flex justify-content-between align-items-center price_summary_children"><label class="price_total_label">Total Base Price</label><span class="price_total_tag">{{totalBasePriceConv}}</span></div>

<div class="d-flex justify-content-between align-items-center price_summary_children">

  <label class="price_total_label">Total Taxes</label><span class="price_total_tag">{{totalTaxesConv}}</span>

</div>
<div class="d-flex justify-content-between align-items-center price_summary_children">

  <label class="price_total_label">Total Discount</label><span class="price_total_tag">{{totalDiscountConv}}</span>

</div>
<div class="d-flex justify-content-between align-items-center price_summary_children">

  <label class="price_total_label">Total ServiceFee</label><span class="price_total_tag">{{totalServiceFeeConv}}</span>

</div>
<div class="d-flex justify-content-between align-items-center price_summary_children">

  <label class="price_total_label">Total ANCI Fee</label><span class="price_total_tag">{{totalANCIConv}}</span>

</div>
<div class="d-flex justify-content-between align-items-center price_summary_children">

  <label class="price_total_label" style="font-weight: 800;font-size:12.5px">Trip Total</label><span class="price_total_tag" style="font-weight:800;font-size:12.5px">{{totalPriceConv}}</span>

</div>
</div> <!-- closes noti col-sm-12 price_summary -->
</div> <!-- closes passenger-summary-content -->
</div> <!-- closes right_side_container -->

<div class="passenger-form-wrapper">
  <!--<div class="noti col-sm-8 notification_area">
  <div class="flight_details" *ngFor="let item of airSegmentDetails">
    <h4>{{item.fromCity}} To {{item.toCity}}</h4>
    <div class="flight_schedule">{{item.carrier}} <span class="dot">|</span> {{item.depatureDateTime}}</div>
    <div class="flight_screen">
      <div class="flight_details_children flight_details_children_flex">
        <img src="assets/img/take-off-24.png">
        <div>
          <div class="flight_schedule_larger"> {{item.depatureDateTime}} -  {{item.fromCity}}</div>
          <div class="flight_schedule" style="white-space:pre-wrap">{{item.fromTerminal}}</div>
        </div>
      </div>
      <div class="flight_details_children flight_details_children_slide_left">
        <div class="flight_schedule flight_time_frame">{{item.flightTime}}</div>
        <div class="flight_schedule flight_time_frame">{{item.carrier}}  {{item.flightNumber}}</div>
      </div>

      <div class="flight_details_children flight_details_children_flex">
        <img src="assets/img/landing-24.png" />
        <div>
          <div class="flight_schedule_larger"> {{item.arrivalDateTime}} -  {{item.toCity}}</div>
          <div class="flight_schedule" style="white-space:pre-wrap">{{item.toTerminal}}</div>
        </div>
      </div>
    </div>
  </div>
</div>-->
<!--<form class="noti col-sm-9">
<div class="form_title">Passenger Information</div>
<div class="que_travel">Who's Traveling?</div>
<div class="travel_que-desc">Travelers name must match govt-issued photo ID exactly</div>

<div class="forms_container_main infant_type" *ngFor="let obj of bookingObj.bookingPassengerInfoProperties; let i = index;">
  <div class="main_form">
    <div class="personal_details">
      <div class="detail_title" *ngIf="obj.passengerType == 1">Adult:</div>
      <div class="detail_title" *ngIf="obj.passengerType == 2">Child:</div>
      <div class="detail_title" *ngIf="obj.passengerType == 3">Infant:</div>
      <span class="detail_sub-title" *ngIf="obj.passengerType == 1">12 years or Above</span>
      <span class="detail_sub-title" *ngIf="obj.passengerType == 2">Less than 12 years</span>
      <span class="detail_sub-title" *ngIf="obj.passengerType == 3">Less than 2 years</span>

      <div class="personal-form">
        <div class="row">
          <div class="col-sm-2">
            <label for="" class="input_lab">Title</label>-->
            <!--<input class="main_text-box" type="text" placeholder="Mr. , Ms, Dr. etc." [(ngModel)]="obj.title" name="title{{i}}">-->
            <!--<select class="main_text-box title_box" [(ngModel)]="obj.title" name="title{{i}}">
            <option *ngIf ="obj.passengerType == 1">
              Mr
            </option>
            <option *ngIf="obj.passengerType == 1">
              Ms
            </option>
            <option *ngIf="obj.passengerType == 1">
              Mrs
            </option>
            <option *ngIf="obj.passengerType == 2 ||obj.passengerType == 3">
              Mstr
            </option>
            <option *ngIf="obj.passengerType == 2 ||obj.passengerType == 3">
              Miss
            </option>
          </select>
        </div>
        <div class="col-sm-4">
          <label for="" class="input_lab">First Name</label>
          <input class="main_text-box" type="text" [(ngModel)]="obj.firstName" name="firstName{{i}}">
        </div>
        <div class="col-sm-4">
          <label for="" class="input_lab">Last Name</label>
          <input class="main_text-box" type="text" [(ngModel)]="obj.lastName" name="lastName{{i}}">
        </div>
        <div class="col-sm-2">
          <label for="" class="input_lab">Gender</label>-->
          <!--<input class="main_text-box" type="text" placeholder="Mr. , Ms, Dr. etc." [(ngModel)]="obj.title" name="title{{i}}">-->
          <!--<select class="main_text-box title_box" [(ngModel)]="obj.paxGender" name="paxGender{{i}}">
          <option>
            Male
          </option>
          <option>
            Female
          </option>
          <option>
            Other
          </option>
        </select>
      </div>
    </div>
    <div class="row">

      <div class="col-sm-4">
        <label for="" class="input_lab">Passport No.</label>
        <input class="main_text-box" type="text" [(ngModel)]="obj.passportNumber" name="passportNumber{{i}}">
      </div>
      <div class="col-sm-4">
        <label for="" class="input_lab">Passport Issued on</label>
        <input class="main_text-box main_text-box-re_padding" type="date" [(ngModel)]="obj.passportValidFrom" name="passportValidFrom{{i}}" (change)="issuanceValidation($event)">
      </div>
      <div class="col-sm-4">
        <label for="" class="input_lab ">Passport Expiry</label>
        <input class="main_text-box main_text-box-re_padding" type="date" [(ngModel)]="obj.passportValidTo" name="passportValidTo{{i}}" (change)="expiryValidation($event)">
      </div>
    </div>
    <div class="row">
      <div class="col-sm-4 custon_inputs">
        <label for="" class="input_lab">Date of Birth</label>
        <input class="main_text-box main_text-box-re_padding" type="date" [(ngModel)]="obj.paxDOB" name="paxDOB{{i}}" id="dob_input" (change)="dobValidation($event, obj.passengerType)">
      </div>
      <div class="col-sm-4 custon_inputs">
        <label for="" class="input_lab ">Nationality</label>
        <ng-select class="custom" [items]="countryList"
          bindLabel="countryName" bindValue="code"
          [searchable]="true"
          [ngModelOptions]="{standalone: true}"
          [(ngModel)]="obj.paxNationality">
        </ng-select>
      </div>
      <div class="col-sm-4 custon_inputs">
        <label for="" class="input_lab ">Country of Issuance</label>
        <ng-select class="custom" [items]="countryList"
          bindLabel="countryName" bindValue="code"
          [searchable]="true"
          [ngModelOptions]="{standalone: true}"
          [(ngModel)]="obj.countryOfIssuance">
        </ng-select>
      </div>

    </div>

    <div style="display:none" >
      <div class="que_travel">Travel Prefrences</div>
      <div class="que_line"></div>-->
      <!--<div class="personal-form">-->
      <!--<div class="row" style="column-gap: 5px;">
      <div class="col-sm-4 custon_inputs">
        <label for="" class="input_lab ">Service Type</label>
        <ng-select class="custom" [items]="serviceTypeList"
          name="serviceType{{i}}"
          bindLabel="serviceItemType" bindValue="serviceID"
          [(ngModel)]="obj.serviceType"
          (change)="changeServiceType(obj.serviceType)">
        </ng-select>
      </div>


      <div class="col-sm-4 custon_inputs description_list_class">
        <label for="" class="input_lab ">Description</label>
        <ng-select class="custom" id="description_list_class"
          name="serviceSubType{{i}}"
          [(ngModel)]="obj.serviceSubType">
          <span *ngIf="selectedValue == 1">
            <ng-option *ngFor="let obj of countryCodeList" value="{{obj}}">{{obj}}</ng-option>
          </span>
          <span *ngIf="selectedValue == 2">
            <ng-option *ngFor="let obj of mealListShow" value="{{obj.mealID}}">{{obj.mealList}}</ng-option>
          </span>
          <span *ngIf="selectedValue == 3">
            <ng-option *ngFor="let obj of seatListShow" value="{{obj.seatID}}">{{obj.seatList}}</ng-option>
          </span>
        </ng-select>
      </div>-->
      <!--<div class="col-sm-4 custon_inputs flyer_list_class"  *ngIf="selectedValue == 1">
      <label for="" class="input_lab ">Description</label>
      <ng-select class="custom" [items]="countryCodeList"
        bindLabel="flyerList" bindValue="flyerID"
        [ngModelOptions]="{standalone: true}"
        [(ngModel)]="obj.serviceSubType">
      </ng-select>
    </div>
    <div class="col-sm-4 custon_inputs meal_list_class"  *ngIf="selectedValue == 2">
      <label for="" class="input_lab ">Description</label>
      <ng-select class="custom" [items]="mealListShow"
        bindLabel="mealList" bindValue="mealID"
        [searchable]="true"
        [ngModelOptions]="{standalone: true}"
        [(ngModel)]="obj.serviceSubType">
      </ng-select>
    </div>
    <div class="col-sm-4 custon_inputs seat_list_class" *ngIf="selectedValue == 3">
      <label for="" class="input_lab ">Description</label>
      <ng-select class="custom" [items]="seatListShow"
        bindLabel="seatList" bindValue="seatID"
        [ngModelOptions]="{standalone: true}"
        [(ngModel)]="obj.serviceSubType">
      </ng-select>
    </div>-->
    <!--<div class="col-sm-3 custon_inputs ffno_class">
    <label for="" class="input_lab ">FFNo/Sectors</label>
    <input type="text" class="main_text-box ffno_class_input" [(ngModel)]="obj.sector" name="sector{{i}}" />
  </div>
</div>
</div>
<div class="meal">Meal is on Request Basis kindely contact our back Office Team</div>-->
<!--</div>-->
<!--</div>
</div>
</div>
</div>

<div class="main_form">
  <div class="notif">
    <i class="uil uil-exclamation-triangle notify_icon"></i>
    <span class="notif_desc">These details will be passed to airline</span>
  </div>
  <div class="row d-flex justify-content-center">
    <div class="col-sm-3 custon_inputs">
      <label for="" class="input_lab required">Mobile</label>
      <input class="main_text-box" type="text" [(ngModel)]="mobile" name="mobile">
    </div>
    <div class="col-sm-3 custon_inputs">
      <label for="" class="input_lab required">Phone</label>
      <input class="main_text-box" type="text" [(ngModel)]="phone" name="phone">
    </div>
    <div class="col-sm-3 custon_inputs">
      <label for="" class="input_lab required">E-mail</label>
      <input class="main_text-box" type="text" [(ngModel)]="email" name="email">
    </div>
  </div>
</div>

<div class="main_form">
  <div class="que_travel">Rules & Restrictions</div>
  <div class="que_line"></div>
  <div class="rules_headings"><i class="uil uil-circle rules_icon"></i>Kindely Check the spelling & reconfirm the passenger name(s) before you book.</div>
  <div class="rules_headings"><i class="uil uil-circle rules_icon"></i>Ticket name changes are not permitted once issued.</div>
  <h3 class="rules_desc">The above mentioned purchased tickets are non-transferable and name changes not permitted.</h3>
  <div class="rules_footer">
    <div class="checkBox">
      <input type="checkbox" [(ngModel)]="agreed" [ngModelOptions]="{standalone: true}" (change)="active()" />
      <div class="accept">I accept the Terms & Conditions.</div>
    </div>-->
    <!-- spinner -->
    <!--<div class="psngr-save">
    <div class="col-md-12 text-center">
      <div class="spinner-border text-primary" *ngIf="userService.showSpinner|async"></div>
    </div>
  </div>
  <div class="rules_buttons">
    <button class="sendButton" (click)="onSubmit()">Continue</button>
    <button class="cancelButton" (click)="cancel()">Cancel</button>
    <div id="response-screen" style="margin-top:15px;text-align:center;font-size:1.2rem;font-weight:bold"></div>
  </div>
</div>
</div>
</form>-->

<form class="noti col-sm-9 form-line-active">
  <div class="form_title">Passenger Information</div>
  <div class="que_travel">Who's Traveling?</div>
  <!--<div class="travel_que-desc">Travelers name must match govt-issued photo ID exactly</div>-->

  @for (obj of bookingObj.bookingPassengerInfoProperties; track obj; let i = $index) {
    <div class="forms_container_main infant_type">
      <div class="main_form">
        <div class="row py-2 m-0">
          <div class="col-md-2 py-2 px-1">
            @if (obj.passengerType == 1) {
            <div class="detail_title" id="ptype{{i}}">Adult:</div>
            }
            @if (obj.passengerType == 2) {
            <div class="detail_title">Child:</div>
            }
            @if (obj.passengerType == 3) {
            <div class="detail_title">Infant:</div>
            }
            @if (obj.passengerType == 1) {
            <span class="detail_sub-title">12 years or Above</span>
            }
            @if (obj.passengerType == 2) {
            <span class="detail_sub-title">Less than 12 years</span>
            }
            @if (obj.passengerType == 3) {
            <span class="detail_sub-title">Less than 2 years</span>
            }
          </div>
          @if (masterPassengerFieldsCriteria.phoneNo) {
          <div class="col-12 col-md-5 py-2 px-1 phone-field-col">
            <!--start here search code-->
            <div class="phone-code-wrapper">
              <label class="input_lab_first" for="ssn_input" style="z-index: 1;font-size:10px">Country Code</label>
              <p-select [options]="countryList"
                        [(ngModel)]="obj.telephoneList.countryAccessCode"
                        optionLabel="countryName" optionValue="countryAccessCode"
                        (onChange)="CountryAccesCode(i)"
                        name="countryAccessCode{{i}}" [filter]="true"
                        filterBy="countryName"
                        placeholder="Select"
                        styleClass="w-full">

                <ng-template pTemplate="selectedItem">
                  @if (obj.telephoneList.countryAccessCode) {
                  <div class="flex align-items-center gap-2" style=" width: 100%; display: flex;">
                    <img src="../../assets/Flags/{{obj.telephoneList.flag}}"
                         (error)="onFlagError($event)" style="width: 18px" />
                    <div>+{{obj.telephoneList.countryAccessCode}}</div>
                  </div>
                  }
                </ng-template>
                <ng-template let-country pTemplate="item">
                  <div class="flex align-items-center gap-2" style=" width: 100%; display: flex;">
                    <img src="../../assets/Flags/{{country.flagsImages}}"
                         (error)="onFlagError($event)" style="width: 18px" />
                    <div style="padding-left:3px"> (+{{country.countryAccessCode}}) {{ country.countryName }}</div>
                  </div>
                </ng-template>
              </p-select>
            </div>
            <div class="phone-input-wrapper">
              <label class="input_lab_first" for="ssn_input">Mobile No</label>
              <input class="main_text-box mobilenumbermask primary-phone-input" [disabled]="!obj.telephoneList.countryAccessCode"
                     [(ngModel)]="obj.telephoneList.phoneNumber" (blur)="getSearchonfocusout(popupsearch,i);copyPrimaryPhoneFromFirstPassenger(i)"
                     placeholder="{{obj.telephoneList.mask}}" name="inputmasktelePrimary{{i}}" id="ssn_input" />
              <button type="button" id="buttonmobilesearch{{i}}" [disabled]="!obj.telephoneList.phoneNumber" (click)="SearchCtcNo(popupsearch,i)" pButton icon="pi pi-search" class="p-button-warning phone-search-btn"></button>
            </div>
            <span class="mobile-required" id="messagepass{{i}}"></span>
          </div>
          }
          @if (masterPassengerFieldsCriteria.phoneNo) {
          <div class="col-12 col-md-5 py-2 px-1 phone-field-col">
            <!--start here search code-->
            <div class="phone-code-wrapper">
              <label class="input_lab_first" for="ssn_inputS" style="z-index: 1;font-size:10px">Country Code</label>
              <p-select [options]="countryList"
                        [(ngModel)]="obj.telephoneListSecondary.countryAccessCode"
                        optionLabel="countryName" optionValue="countryAccessCode"
                        (onChange)="CountryAccesCodeSecondary(i)"
                        name="countryAccessCodeSecondary{{i}}" [filter]="true"
                        filterBy="countryName"
                        placeholder="Select"
                        styleClass="w-full">

                <ng-template pTemplate="selectedItem">
                  @if (obj.telephoneListSecondary.countryAccessCode) {
                  <div class="flex align-items-center gap-2" style=" width: 100%; display: flex;">
                    <img src="../../assets/Flags/{{obj.telephoneListSecondary.flag}}"
                         (error)="onFlagError($event)" style="width: 18px" />
                    <div>+{{obj.telephoneListSecondary.countryAccessCode}}</div>
                  </div>
                  }
                </ng-template>
                <ng-template let-country pTemplate="item">
                  <div class="flex align-items-center gap-2" style=" width: 100%; display: flex;">
                    <img src="../../assets/Flags/{{country.flagsImages}}"
                         (error)="onFlagError($event)" style="width: 18px" />
                    <div style="padding-left:3px"> (+{{country.countryAccessCode}}) {{ country.countryName }}</div>
                  </div>
                </ng-template>
              </p-select>
            </div>
            <div class="phone-input-wrapper">
              <label class="input_lab_first" for="ssn_inputS">Mobile No</label>
              <input class="main_text-box mobilenumbermask secondary-phone-input" [disabled]="!obj.telephoneListSecondary.countryAccessCode"
                     [(ngModel)]="obj.telephoneListSecondary.phoneNumber" placeholder="{{obj.telephoneListSecondary.mask}}" name="inputmaskteleSecondary{{i}}" id="ssn_inputS" (blur)="focusOutSecondaryNumber(i);copySecondaryPhoneFromFirstPassenger(i)" />
            </div>
            <span class="mobile-required" id="messagepassSec{{i}}"></span>
          </div>
          }
          <ng-template #popupsearch let-modal>
            <div class="modal-header passenger-profile-modal-header">
              <div class="modal-header-title-wrap">
                <div class="modal-header-icon">
                  <i class="fas fa-id-card"></i>
                </div>
                <div>
                  <h4 class="modal-title">Passenger Profile Details</h4>
                  <span class="modal-subtitle">Select saved passenger to auto-fill details</span>
                </div>
              </div>
              <button type="button" class="close btn-modal-close" aria-label="Close" (click)="modal.dismiss()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body passenger-profile-modal-body">
              <div class="alert alert-danger hiddenclasspstype newpswarn" id="pstypealert" role="alert">
                Please Select<strong id="warningPsType"></strong>
              </div>
              <div id="grids" class="passenger-profile-grid-wrap">
                <dx-data-grid id="grid"
                              [dataSource]="searchprofileCred"
                              [showBorders]="true"
                              [showRowLines]="true"
                              [columnAutoWidth]="true"
                              width="100%">
                  <dxo-selection mode="single"></dxo-selection>
                  <dxo-paging [pageSize]="10"></dxo-paging>
                  <dxo-filter-row [visible]="true"></dxo-filter-row>

                  <!-- ACTION BUTTON MOVED TO START (FIRST COLUMN) -->
                  <dxi-column caption="Action" [allowSorting]="false" alignment="center" cellTemplate="actionCellTemplate" [width]="105" [fixed]="true" fixedPosition="left"></dxi-column>

                  <dxi-column [visible]="false" dataType="number" dataField="profile_Id" alignment="center"></dxi-column>
                  <dxi-column dataField="title" caption="Title" dataType="string" alignment="center" [width]="70"></dxi-column>
                  <dxi-column dataField="firstName" caption="First Name" dataType="string" alignment="left"></dxi-column>
                  <dxi-column dataField="lastName" caption="Last Name" dataType="string" alignment="left"></dxi-column>
                  <dxi-column dataField="paxGender" [visible]="false" caption="Gender" dataType="string" alignment="center"></dxi-column>
                  <dxi-column dataField="paxDOB" [visible]="false" caption="DOB" dataType="date" alignment="center"></dxi-column>
                  <dxi-column dataField="mobile_No" [visible]="false" caption="Mobile No" dataType="string" alignment="center"></dxi-column>
                  <dxi-column dataField="mobileSecondary" caption="Mobile No" dataType="string" alignment="center"></dxi-column>
                  <dxi-column dataField="passportValidTo" caption="Passport Expiry" dataType="date" alignment="center"></dxi-column>
                  <dxi-column dataField="passportNumber" caption="Passport No" dataType="string" alignment="center"></dxi-column>
                  <dxi-column dataField="passengerType" [visible]="false" dataType="string" alignment="center"></dxi-column>
                  <dxi-column dataField="passengerTypeName" caption="Passenger Type" dataType="string" alignment="center" [width]="120"></dxi-column>
                  <dxi-column dataField="paxNationality" [visible]="false" caption="Nationality" dataType="string" alignment="center"></dxi-column>
                  <dxi-column dataField="email_Id" [visible]="false" dataType="string" caption="Email" alignment="center"></dxi-column>
                  <dxi-column dataField="frequent_Flyer_No" [visible]="false" caption="Frequent Flyer No" dataType="string" alignment="center"></dxi-column>
                  <dxi-column dataField="countryOfIssuance" caption="Country of Issuance" dataType="string" alignment="center"></dxi-column>

                  <div *dxTemplate="let data of 'actionCellTemplate'">
                    <a class="profilesearchbutton" (click)="Select_Profiledata(data.data)" title="Select passenger profile">
                      <i class="fas fa-check-circle"></i>
                      <span>Select</span>
                    </a>
                  </div>
                </dx-data-grid>
              </div>
              <div class="modal-footer">
              </div>
            </div>
          </ng-template>
        </div>
        <div class="row m-0 py-2">
          @if (masterPassengerFieldsCriteria.title) {
          <div class="col-sm-2 poisiton_Columns  px-1">
            <!--<input class="main_text-box" type="text" placeholder="Mr. , Ms, Dr. etc." [(ngModel)]="obj.title" name="title{{i}}">-->
            <select class="main_text-box title_box" [(ngModel)]="obj.title" id="titles{{i}}" (change)="genderSelectonGivenTitle(i)" name="title{{i}}">
              @if (obj.passengerType == 1) {
              <option>
                Mr
              </option>
              }
              @if (obj.passengerType == 1) {
              <option>
                Ms
              </option>
              }
              @if (obj.passengerType == 1) {
              <option>
                Mrs
              </option>
              }
              @if (obj.passengerType == 2 ||obj.passengerType == 3) {
              <option>
                Mstr
              </option>
              }
              @if (obj.passengerType == 2 ||obj.passengerType == 3) {
              <option>
                Miss
              </option>
              }
            </select>
            <div>
              <label for="" class="input_lab_first" id="titlelabel{{i}}">Title</label>
            </div>
            <div>
              <span class="first-required" id="messageTitleRquired{{i}}"></span>
            </div>
          </div>
          }
          @if (masterPassengerFieldsCriteria.firstName) {
          <div class="col-sm-4 poisiton_Columns  px-1">
            <input class="main_text-box new_main_Text_Box " (blur)="toTitleCase(i,obj.firstName,$event)" [(ngModel)]="obj.firstName" id="firstname{{i}}" name="firstName{{i}}" type="text" />
            <div>
              <label for="" class="input_lab_first" id="firstlabel{{i}}">First Name</label>
            </div>
            <div>
              <span class="first-required" id="messageFirstnameRquired{{i}}"></span>
            </div>
          </div>
          }
          @if (masterPassengerFieldsCriteria.lastName) {
          <div class="col-sm-4 poisiton_Columns  px-1">
            <input class="main_text-box" type="text" (blur)="toTitleCase(i,obj.lastName,$event)" [(ngModel)]="obj.lastName" id="lastname{{i}}" name="lastName{{i}}">
            <div>
              <label for="" class="input_lab_first" id="lastlabel{{i}}">Last Name</label>
            </div>
            <div>
              <span class="first-required" id="messagelastnameRquired{{i}}"></span>
            </div>
          </div>
          }
          @if (masterPassengerFieldsCriteria.gender) {
          <div class="col-sm-2  poisiton_Columns  px-1">
            <!--<input class="main_text-box" type="text" placeholder="Mr. , Ms, Dr. etc." [(ngModel)]="obj.title" name="title{{i}}">-->
            <select class="main_text-box title_box " [(ngModel)]="obj.paxGender" id="gender{{i}}" name="paxGender{{i}}">
              <option id="male{{i}}">
                Male
              </option>
              <option id="female{{i}}">
                Female
              </option>
              <option>
                Other
              </option>
            </select>
            <div>
              <label for="" class="input_lab_first" id="genderlabel{{i}}">Gender</label>
            </div>
            <div>
              <span class="first-required" id="messagegenderRquired{{i}}"></span>
            </div>
          </div>
          }
        </div>
        <div class="row m-0">
          @if (masterPassengerFieldsCriteria.passport) {
          <div class="col-sm-2 pb-2 px-1">
            <input class="main_text-box " type="text" [(ngModel)]="obj.passportNumber" (change)="onPassportNumberChange(i)" id="passportnum{{i}}" name="passportNumber{{i}}">
            <div>
              <label for="" class="input_lab_first " id="ppnlabel{{i}}">Passport No</label>
            </div>
            <div>
              <span class="first-required" id="messagePPNRquired{{i}}"></span>
            </div>
          </div>
          }
          <!--<div class="col-sm-4" *ngIf="J9Anxi">
      <label for="" class="input_lab">Passport Issued on</label>
      <input class="main_text-box" type="date" [(ngModel)]="obj.passportValidFrom" id="pasportdatefrom{{i}}" name="passportValidFrom{{i}}" (change)="issuanceValidation($event)">
    </div>-->
          @if ((J9Anxi || bookingBaseData.supplierCode == 'EK'|| bookingBaseData.supplierCode == 'FT') && masterPassengerFieldsCriteria.passportIssueDate) {
          <div class="col-sm-4 pb-2 px-1">
            <input class="main_text-box new_main_Text_Box" type="date" [(ngModel)]="obj.passportValidFrom" id="pasportdatefrom{{i}}" name="passportValidFrom{{i}}" (change)="issuanceValidation(obj.passportValidFrom,i)">
            <div>
              <label for="" class="input_lab_first " id="labelfromissue{{i}}">Passport Issued on</label>
            </div>
            <div>
              <span class="first-required" id="messagePasportfromRquired{{i}}"></span>
            </div>
          </div>
          }
          @if (masterPassengerFieldsCriteria.passportExpiryDate) {
          <div class="col-sm-4 pb-2 px-1">
            <input class="main_text-box new_main_Text_Box" type="date" [(ngModel)]="obj.passportValidTo" id="pasportvalidto{{i}}" name="passportValidTo{{i}}">
            <div>
              <label for="" class="input_lab_first " id="pexplabel{{i}}">Passport Expiry</label>
            </div>
            <div>
              <span class="first-required" id="messagePassExpRquired{{i}}"></span>
            </div>
          </div>
          }
          @if (masterPassengerFieldsCriteria.countryOfIssuance) {
          <div class="col-sm-4 pb-2 px-1">
            <ng-select class="country-issuance-Class   countryOfIssueclass" [items]="countryList"
                       id="countryborderClass{{i}}"
                       bindLabel="countryName" bindValue="code"
                       [searchable]="true"
                       (click)="CountryofIsuuance_Focus_Input(i)"
                       (blur)="Coi_Focus(i)"
                       placeholder="Select"
                       [ngModelOptions]="{standalone: true}"
                       [(ngModel)]="obj.countryOfIssuance">
            </ng-select>
            <div>
              <label for="" class="input_lab_first" id="countryLabel{{i}}">Country of Issuance</label>
            </div>
            <div>
              <span class="first-required" id="messageCoIRquired{{i}}"></span>
            </div>
          </div>
          }
          @if (masterPassengerFieldsCriteria.frequentFlyerNo) {
          <div class="col-sm-2 pb-2 px-1">
            <input class="main_text-box" type="text" [(ngModel)]="obj.frequent_Flyer_No" id="Frequent_Flyer_No{{i}}" name="Frequent_Flyer_Nos{{i}}">
            <div>
              <label for="" class="input_lab_first">Frequent Flyer No</label>
            </div>
            <div>
              <span class="first-required" id="messageFFNRquired{{i}}"></span>
            </div>
          </div>
          }
        </div>
        <div class="row m-0 ">
          @if (masterPassengerFieldsCriteria.dateOfBirth) {
          <div class="col-sm-4  px-1">
            <input class="main_text-box" type="date" [(ngModel)]="obj.paxdob" name="paxDOB{{i}}" id="dob_input{{i}}">
            <div>
              <label for="" class="input_lab_first" id="doblabel{{i}}">Date of Birth</label>
            </div>
            <div>
              <span class="first-required" id="messageDobRquired{{i}}"></span>
            </div>
            <!--<input class="main_text-box text-lowercase" type="text" [(ngModel)]="obj.email" id="email{{i}}" name="email{{i}}">
      <label for="email" class="input_lab_email">Email</label>-->
          </div>
          }
          <!--<div class="col-sm-3" *ngIf="J9Anxi">
      <label for="" class="input_lab-expiry">Passport Issued on</label>
      <input class="main_text-box" type="date"  [(ngModel)]="obj.passportValidFrom" id="pasportdatefrom{{i}}" name="passportValidFrom{{i}}" (change)="issuanceValidation($event)">
    </div>-->
          @if (masterPassengerFieldsCriteria.nationality) {
          <div class="col-sm-4  px-1">
            <ng-select class="nationalityClass  "
                       id="nationcc{{i}}"
                       [items]="countryList"
                       placeholder="Select"
                       bindLabel="countryName" bindValue="code"
                       [searchable]="true"
                       (click)="Nation_Focus(i)"
                       (blur)="Coi_Focus(i)"
                       [ngModelOptions]="{standalone: true}"
                       [(ngModel)]="obj.paxNationality">
            </ng-select>
            <div>
              <label for="" class="input_lab_first" id="nationLabel{{i}}">Nationality</label>
            </div>
            <div>
              <span class="first-required" id="messageNationRquired{{i}}"></span>
            </div>
          </div>
          }
          @if (masterPassengerFieldsCriteria.email) {
          <div class="col-sm-4 px-1">
            <input class="main_text-box" type="text" [(ngModel)]="obj.email" id="email{{i}}" name="email{{i}}" (blur)="emailverifyregex(obj.email,i);copyEmailFromFirstPassenger(i)">
            <div>
              <label for="email" class="input_lab_first" id="emaillabel{{i}}">Email</label>
            </div>
            <div>
              <span class="first-required" id="messageEmailRquired{{i}}"></span>
            </div>
          </div>
          }
        </div>
        @if (airsialpaskistan) {
        <div class="row m-0">
          <div class="col-sm-4 pb-2 px-1">
            <input class="main_text-box " type="text" (blur)="chnagepscnic(i)" [(ngModel)]="obj.cnic" id="cnicnum{{i}}" name="cnic{{i}}">
            <div>
              <label for="" class="input_lab_first " id="cniclabel{{i}}">CNIC No</label>
            </div>
            <div>
              <span class="first-required" id="cnicnummsg{{i}}"></span>
            </div>
          </div>
        </div>
        }
        @if (isDomesticRouteForFlyAdeal) {
        <div class="row m-0">
          <div class="col-sm-4 pb-2 px-1">
            <input class="main_text-box " type="text" (blur)="validateSaudiNationalIdAndIqama(i)" [(ngModel)]="obj.cnic" id="cnicnum{{i}}" name="cnic{{i}}">
            <div>
              <label for="" class="input_lab_first " id="cniclabel{{i}}">NationalID/Iqama No</label>
            </div>
            <div>
              <span class="first-required" id="cnicnummsg{{i}}"></span>
            </div>
          </div>
        </div>
        }
        @if (obj.passengerType == 3) {
        <div class="row m-0">
          <div class="col-sm-4 pb-2 px-1">
            <ng-select class="nationalityClass  "
                       id="Personrspinfant{{i}}"
                       [disabled]="associatedInfant"
                       [items]="associatedadultNameList"
                       placeholder="Select"
                       bindLabel="adultName" bindValue="adultfirstName"
                       [searchable]="true"
                       (click)="AssociatedAdultsWithInfant(i)"
                       (blur)="focusoutassociatedadult(i)"
                       [ngModelOptions]="{standalone: true}"
                       [(ngModel)]="obj.associatedAdult">
            </ng-select>
            <div>
              <label for="" class="input_lab_first " id="Personrspinfantlabel{{i}}">Person responsible for the infant</label>
            </div>
            <div>
              <span class="first-required" id="Personrspinfantmsg{{i}}"></span>
            </div>
          </div>
        </div>
        }
        <div style="display:none">
          <div class="que_travel">Travel Prefrences</div>
          <div class="que_line"></div>
          <!--<div class="personal-form">-->
          <div class="row" style="column-gap: 5px;">
            <div class="col-sm-4 custon_inputs">
              <label for="" class="input_lab ">Service Type</label>
              <ng-select class="custom" [items]="serviceTypeList"
                         name="serviceType{{i}}"
                         bindLabel="serviceItemType" bindValue="serviceID"
                         [(ngModel)]="obj.serviceType"
                         (change)="changeServiceType(obj.serviceType)">
              </ng-select>
            </div>
            <div class="col-sm-4 custon_inputs description_list_class">
              <label for="" class="input_lab ">Description</label>
              <ng-select class="custom" id="description_list_class"
                         name="serviceSubType{{i}}"
                         [(ngModel)]="obj.serviceSubType">
                @if (selectedValue == 1) {
                <span>
                  @for (obj of countryCodeList; track obj) {
                  <ng-option value="{{obj}}">{{obj}}</ng-option>
                  }
                </span>
                }
                @if (selectedValue == 2) {
                <span>
                  @for (obj of mealListShow; track obj) {
                  <ng-option value="{{obj.mealID}}">{{obj.mealList}}</ng-option>
                  }
                </span>
                }
                @if (selectedValue == 3) {
                <span>
                  @for (obj of seatListShow; track obj) {
                  <ng-option value="{{obj.seatID}}">{{obj.seatList}}</ng-option>
                  }
                </span>
                }
              </ng-select>
            </div>
            <!--<div class="col-sm-4 custon_inputs flyer_list_class"  *ngIf="selectedValue == 1">
        <label for="" class="input_lab ">Description</label>
        <ng-select class="custom" [items]="countryCodeList"
          bindLabel="flyerList" bindValue="flyerID"
          [ngModelOptions]="{standalone: true}"
          [(ngModel)]="obj.serviceSubType">
        </ng-select>
      </div>
      <div class="col-sm-4 custon_inputs meal_list_class"  *ngIf="selectedValue == 2">
        <label for="" class="input_lab ">Description</label>
        <ng-select class="custom" [items]="mealListShow"
          bindLabel="mealList" bindValue="mealID"
          [searchable]="true"
          [ngModelOptions]="{standalone: true}"
          [(ngModel)]="obj.serviceSubType">
        </ng-select>
      </div>
      <div class="col-sm-4 custon_inputs seat_list_class" *ngIf="selectedValue == 3">
        <label for="" class="input_lab ">Description</label>
        <ng-select class="custom" [items]="seatListShow"
          bindLabel="seatList" bindValue="seatID"
          [ngModelOptions]="{standalone: true}"
          [(ngModel)]="obj.serviceSubType">
        </ng-select>
      </div>-->
            <div class="col-sm-3 custon_inputs ffno_class">
              <label for="" class="input_lab ">FFNo/Sectors</label>
              <input type="text" class="main_text-box ffno_class_input" [(ngModel)]="obj.sector" name="sector{{i}}" />
            </div>
          </div>
        </div>
        <!--<div class="meal" >Meal is on Request Basis kindely contact our back Office Team</div>-->
        <!--</div>-->
        @if (fzAnxii && obj.passengerType != 3) {
        <div hidden>
          <div>
            <p class="exta-desc">Extra Services</p>
            @for (sector of obj.sectorInformationProperties; track sector; let f = $index) {
            <div class="anci_section_FZ">
              <div>
                <button class="anxi-fz-button" (click)="fzMealClick(i,f)">MEAL</button>
                <!-- ///////////////////////////////////////////////////meal FZ -->
                <div class="fz-meal-container meal-no" id="fz-meal-container{{i}}{{f}}">
                  <!--<span class="close">&times;</span>-->
                  <div class="fz-meal-selected">
                    <p class="exta-desc-repeater">Selected Meal</p>
                    <div class="meal-selected-description">
                      <p class="fz-mdis">Meal Description:</p>
                      <p class="fz-sm">{{sector.mealname}}</p>
                      <p class="fz-mcode">Meal Code:</p>
                      <p class="fz-sm">{{sector.meal}}</p>
                      <p class="fz-mprice">Meal Price:</p>
                      <p class="fz-sm">{{sector.mealFee}}</p>
                    </div>
                  </div>
                  <div class="fz-meal-repeater">
                    <p class="exta-desc-repeater">Meal Selection</p>
                    @for (meals of fzMealArray; track meals; let m = $index) {
                    <div class="meal-repeater-outer">
                      <p class="fz-meal-name">{{meals.description}}</p>
                      <p class="fz-meal-price">{{meals.currency}}{{meals.amount}}</p>
                      <button class="fz-meal-btn" (click)="fzMealSelect(i,f,m)">Select</button>
                    </div>
                    }
                  </div>
                </div>
              </div>
              <div>
                <button class="anxi-fz-button" (click)="fzBaggageClick(i,f,poperrornot)">Baggage</button>
                <div class="fz-meal-container meal-no" id="fz-baggage-container{{i}}{{f}}">
                  <!--<span class="close">&times;</span>-->
                  <div class="fz-meal-selected">
                    <p class="exta-desc-repeater">Selected Baggage</p>
                    <div class="meal-selected-description">
                      <p class="fz-mdis">Baggage Description:</p>
                      <p class="fz-sm">{{sector.baggagename}}</p>
                      <p class="fz-mcode">Baggage Code:</p>
                      <p class="fz-sm">{{sector.baggageCode}}</p>
                      <p class="fz-mprice">Baggage Price:</p>
                      <p class="fz-sm">{{sector.baggageFee}}</p>
                    </div>
                  </div>
                  <div class="fz-meal-repeater">
                    <p class="exta-desc-repeater">Baggage Selection</p>
                    @for (meals of fzBaggageArray; track meals; let m = $index) {
                    <div class="meal-repeater-outer">
                      <p class="fz-meal-name">{{meals.description}}</p>
                      <p class="fz-meal-price">{{meals.currency}}{{meals.amount}}</p>
                      <button class="fz-meal-btn" (click)="fzBaggageSelect(i,f,m)">Select</button>
                    </div>
                    }
                  </div>
                </div>
              </div>
              <div>
                <button class="anxi-fz-button">Seat</button>
              </div>
            </div>
            }
          </div>
        </div>
        }
        <!-------------------------------------------------------------------------- Aljazeera start----------------------- -->
        <!--------------------------------------------------------------------------------------- Aljazeera ends --------------- -->
        <!-------------------------------------------------------------------------- spice start----------------------- -->
        @if (SpiceAnxi  && obj.passengerType != 3) {
        <div>
          <div>
            <p class="exta-desc">Extra Services</p>
            @for (sector of obj.sectorInformationProperties; track sector; let f = $index) {
            <div class="anci_section_FZ">
              <div class="row">
                <span class="sectorname">{{sector.fromAirport}} <i class="fas fa-plane-arrivals" style="margin-right:4px;margin-left:4px;color:black"></i> {{sector.toAirport}}</span>
              </div>
              <div class="anci_Section_columns">
                <div class="anci_columns_head">
                  <div class="anci_columns_subhead">
                    <span class="anci_column_subject">Meal</span>
                    <span class="anci_column_name">{{sector.mealname}}</span>
                  </div>
                  <!-- *ngIf="SpiceDirect" -->
                  <div style=" width: 10%">
                    @if (sector.mealbtn) {
                    <button class="anci_column_edit" (click)="SpiceMealClick(i,f,poperrornot)"><i class="fas fa-edit"></i></button>
                    }
                    <!--<button class="anci_column_edit" *ngIf="SpiceViaT && (f==0 || f==2)" (click)="SpiceMealClick(i,f,poperrornot)"><i class="fas fa-edit"></i></button>
              <button class="anci_column_edit" *ngIf="SpiceConnecting && (f==0 || f==2)" (click)="SpiceMealClick(i,f,poperrornot)"><i class="fas fa-edit"></i></button>-->
                    <!--popup of meal-->
                    <div id="mealpopup{{i}}{{f}}" class="numofseatmodel">
                      <div class="modal modal-lg" tabindex="-1" role="dialog" style="max-width: 100% !important; ">
                        <div class="modal-dialog modal-lg " role="document" style="position: absolute; left: 250px;width:100%;">
                          <div class="modal-content" style="width:100% !important">
                            <div class="modal-header">
                              <div class="seat_model_header">
                                <span style="font-size: 20px; color: white; font-weight: bold; letter-spacing: 2px; ">Meal Selection</span>
                                <button style=" position: absolute; right: 16px; color: white; opacity: 1;" type="button" class="close" (click)="mealclose(i,f)" data-dismiss="modal" aria-label="Close">
                                  <span aria-hidden="true">&times;</span>
                                </button>
                              </div>
                            </div>
                            <div class="modal-body" style="padding: 0px !important;">
                              <div style="width:100%;">
                                <div style="width: 100%; padding: 6px;">
                                  <div class="mt-2 seat_info">
                                    <span class="seat_info_header" style="background-color: #39454B;">
                                      {{sector.fromAirport}} <i class="fas fa-plane-arrivals" style="margin-right:8px;margin-left:8px;color:white"></i> {{sector.toAirport}}
                                    </span>
                                    <div class="row">
                                      <div style="width:30%">
                                        <span class="seat_info_one_head ">
                                          Passenger Name:
                                        </span>
                                      </div>
                                      <div style="width:70%">
                                        <span class="seat_info_one">
                                          {{obj.title}} {{obj.firstName}} {{obj.lastName}}
                                        </span>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div style="width:30%">
                                        <span class="seat_info_one_head ">
                                          Meal Name:
                                        </span>
                                      </div>
                                      <div style="width: 70%; ">
                                        <span class="seat_info_one">
                                          {{sector.mealname}}
                                        </span>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div style="width:30%">
                                        <span class="seat_info_one_head ">
                                          Meal Charges:
                                        </span>
                                      </div>
                                      <div style="width:70%">
                                        @if (bookingBaseData.supplierCode == 'SG') {
                                        <span class="seat_info_one">
                                          {{currency}} {{(sector.mealFee * currencyRate)| number: '1.1-2'}}
                                        </span>
                                        }
                                        <!--<span class="seat_info_one" *ngIf="bookingBaseData.supplierCode == 'J9'">
                                    {{currency}} {{(sector.mealFee)| number: '1.1-2'}}
                                  </span>-->
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div style="width:100%;padding:6px;height:33rem;overflow:auto;">
                                  @for (mealsector of mealListJ; track mealsector; let m = $index) {
                                  <div class="meal_deatils_main">
                                    <div class="meal_Section">
                                      <div class="meal_section_one_image">
                                        <img style="height: 110px; width: 123px; background-size: contain; background-repeat: no-repeat; background-position: center; background-color: #fff;" src="../../assets/img/restaurant-thumbnail.png" />
                                      </div>
                                      <div class="meal_Section_deatils">
                                        <div class="meal_details_heading">
                                          <div class="meal_details_heading_section_one">
                                            <!--.PaxSSRPriceList[0].PaxFee.ServiceCharges[0].ChargeDetail-->
                                            <span style="font-weight:bold;font-size:18px;color:black;">{{mealsector.PaxSSRPriceList[0].PaxFee.ServiceCharges[0].ChargeDetail}}</span>
                                            <span style="font-size:12px;color:black;">
                                              MEAL:{{mealsector.SSRCode}}
                                            </span>
                                          </div>
                                          <div class="meal_details_heading_section_two" style="display:flex;justify-content:end">
                                            <span style="font-weight:bold;font-size:21px;">{{currency}} {{(mealsector.PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount)}}</span>
                                          </div>
                                        </div>
                                        <div class="meal_deatils_button">
                                          <button class="meal_button_add" id="mealselectbtn{{i}}{{f}}{{m}}" (click)="spiceSelectMeal(i,f,m)"><span id="mealselectid{{i}}{{f}}{{m}}">Select</span></button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--end meal popup-->
                  </div>
                </div>
              </div>
              <!--seat map of anci selectio -->
              @if (this.bookingBaseData.supplierCode == 'SG' ) {
              <div class="anci_Section_columns" style="margin-left:0.4%">
                <div class="anci_columns_head">
                  <div class="anci_columns_subhead">
                    <span class="anci_column_subject">Seat</span>
                    <span class="anci_column_name">{{sector.seatNumber}}</span>
                  </div>
                  <div style=" width: 10%">
                    @if (sector.seatbtn) {
                    <button class="anci_column_edit" (click)="spiceSeatMapOpen(i,f)" id="seatselectid{{i}}{{f}}"><i class="fas fa-edit"></i></button>
                    }
                    <div id="newmodelofseat{{i}}{{f}}" class="SpiceSeatmodel">
                      <div class="modal modal-lg" tabindex="-1" role="dialog" style="max-width: 100% !important; ">
                        <div class="modal-dialog modal-lg modal-dialog-centered" role="document" style="position: absolute; left: 250px;width:100%;">
                          <div class="modal-content" style="width:100% !important">
                            <div class="modal-header">
                              <div class="seat_model_header">
                                <span style="font-size: 20px; color: white; font-weight: bold; letter-spacing: 2px; ">Seat Selection</span>
                                <button style=" position: absolute; right: 16px; color: white; opacity: 1;" type="button" class="close" (click)="SpiceSeatMapclose(i,f)" data-dismiss="modal" aria-label="Close">
                                  <span aria-hidden="true">&times;</span>
                                </button>
                              </div>
                            </div>
                            <div class="modal-body" style="padding: 0px !important;">
                              <div class="seat_model_body_one">
                                <div class="seat_model_body_two">
                                  <span class="seat_info_header">
                                    Seatmap Legend
                                  </span>
                                  <div class="row mb-2">
                                    <div class="col-md-3">
                                      <button class="square-skew " disabled>
                                        <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                        <!--<span class="tooltip-text" id="top{{k}}{{q}}">I'm a tooltip!</span>-->
                                      </button>
                                    </div>
                                    <div class="col-md-9">
                                      <span>Seat Available</span>
                                    </div>
                                  </div>
                                  <div class="row mb-2">
                                    <div class="col-md-3">
                                      <button class="square-skew_not not_avail_Seat" disabled>
                                        <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                        <!--<span class="tooltip-text" id="top{{k}}{{q}}">I'm a tooltip!</span>-->
                                      </button>
                                    </div>
                                    <div class="col-md-9">
                                      <span>Seat Unavailable</span>
                                    </div>
                                  </div>
                                  <div class="row mb-2">
                                    <div class="col-md-3">
                                      <button class="square-skew" style="background-color:var(--first-color-second)" disabled>
                                        <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                        <!--<span class="tooltip-text" id="top{{k}}{{q}}">I'm a tooltip!</span>-->
                                      </button>
                                    </div>
                                    <div class="col-md-9">
                                      <span>Seat Selected</span>
                                    </div>
                                  </div>
                                  <div class="row ">
                                    <div class="col-md-3">
                                      <button class="square-skew_not" style="background-color:orangered" disabled>
                                        <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                        <!--<span class="tooltip-text" id="top{{k}}{{q}}">I'm a tooltip!</span>-->
                                      </button>
                                    </div>
                                    <div class="col-md-9">
                                      <span>Seat Selected By Another Passenger</span>
                                    </div>
                                  </div>
                                </div>
                                <div class="mt-2 seat_info">
                                  <span class="seat_info_header">
                                    Seat Information
                                  </span>
                                  <span class="seat_info_header_sector">
                                    {{sector.fromAirport}} To {{sector.toAirport}}
                                  </span>
                                  <div class="row">
                                    <div class="col-md-4">
                                      <span class="seat_info_one_head ">
                                        Name:
                                      </span>
                                    </div>
                                    <div class="col-md-8" style="overflow:hidden;display:flex">
                                      <span class="seat_info_one">
                                        {{obj.firstName}}
                                      </span>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-md-4">
                                      <span class="seat_info_one_head ">
                                        Seat No:
                                      </span>
                                    </div>
                                    <div class="col-md-8">
                                      <span class="seat_info_one">
                                        {{sector.seatNumber}}
                                      </span>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-md-7">
                                      <span class="seat_info_one_head ">
                                        Seat Charges:
                                      </span>
                                    </div>
                                    <div class="col-md-5">
                                      <span class="seat_info_one">
                                        {{currency}} {{((sector.seatFee * currencyRate)| number: '1.1-2')}}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="seat_mdl_bdy_airone">
                                <div class="seat_mdl_bdy_airtwo">
                                  <div>
                                    <img class="seat_wing_one" src="data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMDAuNDMgMTQyLjA5Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZhMDt9LmNscy0ye2ZpbGw6IzAyMDAxNDt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjg3LjY0LDM1Ny41OWE3LDcsMCwwLDEtNi44Myw3LjE3aDBhNyw3LDAsMCwxLTcuMTctNi44NGwtLjkxLTM4LjE2YTcsNywwLDAsMSw2LjgzLTcuMThoMGE3LDcsMCwwLDEsNy4xOCw2Ljg1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIyMi4zMSAtMjIyLjY4KSIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTM0Mi41NCwzNDIuODhhNyw3LDAsMCwxLTYuODQsNy4xN2gwYTcsNywwLDAsMS03LjE3LTYuODRsLS45MS0zOC4xNmE3LDcsMCwwLDEsNi44NC03LjE4aDBhNyw3LDAsMCwxLDcuMTcsNi44NFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMjIuMzEgLTIyMi42OCkiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0zOTcuNDMsMzI4LjE2YTcsNywwLDAsMS02Ljg0LDcuMThoMGE3LDcsMCwwLDEtNy4xOC02Ljg0bC0uOTEtMzguMTZhNyw3LDAsMCwxLDYuODUtNy4xOGgwYTcsNywwLDAsMSw3LjE4LDYuODVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzA0Ljc3LDI0OC43OWwuNTQsMjIuODdhMTMuNzksMTMuNzksMCwwLDAsNi4wNywxMS4wOWw3LjY1LDUuMTcsMTMuMTEtOS43OC0uNzItMzBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzU0LjMxLDIyMy4zMWwuNTQsMjIuODhhMTMuNzksMTMuNzksMCwwLDAsNi4wNywxMS4wOWw3LjY1LDUuMTYsMTMuMS05Ljc4LS43MS0zMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMjIuMzEgLTIyMi42OCkiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik00MjAuNzEsMjIyLjcxbDIsODUuMjItMzYuMjguODdMMjIyLjMxLDM1NS42OWMyLjg5LTIwLDIuMTUtMzIuMDcsMTUuMTUtMzguNzVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PC9zdmc+">
                                  </div>
                                  <div class="aircraft">
                                    <div class="aircraft-head">
                                      <!-- <div class="aircraft-head_inner"> -->
                                      <img style="width: 180px; padding-top: 32px;"
                                           src="data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNTYuNDUgMTUzLjUzIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzAyMDAxNDt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNjM1LjQsNzNzLTI5LjI3LDYuMTMtNDcuNjYsNDdMNTk4LDE0NS41M3MyMC40Mi0yOC45MywzNy40NC0yOC45M1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01NjAuMzQgLTczLjAxKSIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTY0MC41MSw3M3Y0Mi41NWE2MC41Nyw2MC41NywwLDAsMSwzNy40NSwzMGwxMS4yMy0yNi4yMVM2NjMuNjYsNzIuMzQsNjQwLjUxLDczWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU2MC4zNCAtNzMuMDEpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNTg1LjcsMTI1Ljc5bDkuODcsMjQuNTFTNTgyLDE3MS43NCw1NzkuOTEsMTg2LjM4bC0xMi41OS05Ljg3UzU3NS44MywxMzguMzgsNTg1LjcsMTI1Ljc5WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU2MC4zNCAtNzMuMDEpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNjkxLjIzLDEyNC4wOWwtOS44NywyNS4xOXMxMy4yOCwyMS43OCwxNiwzNy4xbDExLjkyLTEwLjg5UzcwMy40OSwxNDUsNjkxLjIzLDEyNC4wOVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01NjAuMzQgLTczLjAxKSIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTU2NS43OSwxODEuNzksNTc3LjUzLDE5MmwtNC45MywyOS40NXMtOS44OCwxMi4wOC0xMi4yNi0zLjI0WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU2MC4zNCAtNzMuMDEpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNjk5LjQsMTkxLjMybDExLjA3LTkuNTNzNi44MSwzMS4xNSw2LjMsMzcuNzhjMCwwLTMuMDcsMTUtMTIuNiwxWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU2MC4zNCAtNzMuMDEpIi8+PC9zdmc+">
                                      <!-- </div> -->
                                    </div>
                                    <div class="aircraft-body-exit-top">
                                      <div class="aircraft-body-exit-left-top">
                                      </div>
                                      <div class="aircraft-body-exit-top-center">
                                      </div>
                                      <div class="aircraft-body-exit-right-top">
                                      </div>
                                    </div>
                                    <div class="aircraft-body-exit">
                                      <div class="aircraft-body-exit-left">
                                        <div class="aircraft-inner-rowclass">
                                          <span>A</span>
                                          <span>B</span>
                                          <span>C</span>
                                        </div>
                                      </div>
                                      <div class="aircraft-body-exit-right">
                                        <div class="aircraft-inner-rowclass">
                                          <span>D</span>
                                          <span>E</span>
                                          <span>F</span>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="aircraft-body-exit-top">
                                      <div class="aircraft-body-exit-left-top">
                                      </div>
                                      <div class="aircraft-body-exit-top-center">
                                      </div>
                                      <div class="aircraft-body-exit-right-top">
                                      </div>
                                    </div>
                                    <div class="aircraft-body-rowClass">
                                      <div class="aircraft-row-innner-body">
                                        <div class="aircraft_inner_divoneJ">
                                          @for (seat of spiceSeats; track seat; let k = $index) {
                                          <div class="aircraft_inner_divtwoJ">
                                            <!-- seat.availability == '5' ||  *ngIf="seatobj.seatStatus == 'VAC' || *ngIf="seat.availability == '5' " -->
                                            @if ((seat.SeatAvailability ==5) && (seat.Text == '')  ) {
                                            <button class="square-skew hover-text" (click)="spiceSeatSelection(i,f,k)" id="link3button{{i}}{{f}}{{k}}">
                                              <span style="width:10rem;" class="jtooltip-text" id="top{{k}}">
                                                Charges:{{seat.Amount}}
                                                Seat No:{{seat.SeatDesignator}}
                                                <!--<p style="width:10rem;">Info:<span style="text-decoration:underline;" *ngFor="let prop of seat.properties">{{prop.code}}|</span></p>-->
                                              </span>
                                              <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                            </button>
                                            }
                                            @if (seat.SeatAvailability != 5 ) {
                                            <button class="square-skew_not not_avail_Seat" disabled id="link3{{k}}">
                                              <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                            </button>
                                            }
                                            @if (seat.Text == 'Occupied' && (seat.SeatAvailability > 0)  ) {
                                            <button class="square-skew_not" style="background-color:orangered;cursor:not-allowed" disabled id="link3{{k}}">
                                              <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                            </button>
                                            }

                                            <!--</div>-->
                                          </div>
                                          }
                                        </div>
                                      </div>
                                    </div>

                                  </div>
                                  <div>
                                    <img style="width: 207px; margin-left: -2px; margin-top: 163px;" src="data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMDAuNDMgMTQyLjA5Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZhMDt9LmNscy0ye2ZpbGw6IzAyMDAxNDt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzU3LjQxLDM1Ny41OWE3LDcsMCwwLDAsNi44Myw3LjE3aDBhNyw3LDAsMCwwLDcuMTctNi44NGwuOTEtMzguMTZhNyw3LDAsMCwwLTYuODMtNy4xOGgwYTcsNywwLDAsMC03LjE4LDYuODVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzAyLjUxLDM0Mi44OGE3LDcsMCwwLDAsNi44NCw3LjE3aDBhNyw3LDAsMCwwLDcuMTctNi44NGwuOTEtMzguMTZhNyw3LDAsMCwwLTYuODQtNy4xOGgwYTcsNywwLDAsMC03LjE3LDYuODRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjQ3LjYxLDMyOC4xNmE3LDcsMCwwLDAsNi44NSw3LjE4aDBhNyw3LDAsMCwwLDcuMTgtNi44NGwuOTEtMzguMTZhNyw3LDAsMCwwLTYuODUtNy4xOGgwYTcsNywwLDAsMC03LjE4LDYuODVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzQwLjI4LDI0OC43OWwtLjU1LDIyLjg3YTEzLjc2LDEzLjc2LDAsMCwxLTYuMDYsMTEuMDlMMzI2LDI4Ny45MmwtMTMuMTEtOS43OC43Mi0zMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMjIuMzEgLTIyMi42OCkiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0yOTAuNzQsMjIzLjMxbC0uNTQsMjIuODhhMTMuODIsMTMuODIsMCwwLDEtNi4wNywxMS4wOWwtNy42NSw1LjE2LTEzLjExLTkuNzguNzItMzBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMjI0LjM0LDIyMi43MWwtMiw4NS4yMiwzNi4yOC44NywxNjQuMTUsNDYuODljLTIuODktMjAtMi4xNS0zMi4wNy0xNS4xNS0zOC43NVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMjIuMzEgLTIyMi42OCkiLz48L3N2Zz4=">
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                </div>
              </div>
              }
              <!--End seat map of anci selection -->
              <!--start of baggage anci selection -->
              <div class="anci_Section_columns" style="margin-left:0.4%">
                <div class="anci_columns_head">
                  <div class="anci_columns_subhead">
                    <span class="anci_column_subject">Baggage</span>
                    <span class="anci_column_name">{{sector.baggageCheckIn ? sector.baggageCheckIn + weightP : ""}}</span>
                  </div>
                  <div style=" width: 10%">
                    <!--airarabia-->
                    @if (bookingBaseData.supplierCode == 'SG') {
                    <div>
                      @if (sector.baggagebtn) {
                      <button class="anci_column_edit" (click)="SpiceBaggageOpen(i,f)"><i class="fas fa-edit"></i></button>
                      }
                      <!--<button class="anci_column_edit" *ngIf="sector.baggagebtn && SpiceViaT && (f==0 || f==2)" (click)="SpiceBaggageOpen(i,f)"><i class="fas fa-edit"></i></button>
                <button class="anci_column_edit" *ngIf="sector.baggagebtn && SpiceConnecting " (click)="SpiceBaggageOpen(i,f)"><i class="fas fa-edit"></i></button>-->
                    </div>
                    }
                    <!--popup of baggage-->
                    <div id="baggagepopup{{i}}{{f}}" class="bagSpicemodel">
                      <div class="modal modal-lg" tabindex="-1" role="dialog" style="max-width: 100% !important; ">
                        <div class="modal-dialog modal-lg " role="document" style="position: absolute; left: 250px;width:100%;">
                          <div class="modal-content" style="width:100% !important">
                            <div class="modal-header">
                              <div class="seat_model_header">
                                <span style="font-size: 20px; color: white; font-weight: bold; letter-spacing: 2px; ">Baggage Selection</span>
                                <button style=" position: absolute; right: 16px; color: white; opacity: 1;" type="button" class="close" (click)="spicebaggageclose(i,f)" data-dismiss="modal" aria-label="Close">
                                  <span aria-hidden="true">&times;</span>
                                </button>
                              </div>
                            </div>

                            <div class="modal-body" style="padding: 0px !important;">
                              <div style="width:100%;display:flex;">
                                <div style="width:30%;padding:6px;">
                                  <div class="mt-2 seat_info">
                                    <span class="seat_info_header">
                                      Baggage Information
                                    </span>
                                    <span class="seat_info_header_sector">
                                      {{sector.fromAirport}} To {{sector.toAirport}}
                                    </span>
                                    <div class="row">
                                      <div class="col-md-4">
                                        <span class="seat_info_one_head ">
                                          Name:
                                        </span>
                                      </div>
                                      <div class="col-md-8" style="overflow:hidden;display:flex">
                                        <span class="seat_info_one">
                                          {{obj.firstName}}
                                        </span>
                                      </div>

                                    </div>
                                    <div class="row">
                                      <div class="col-md-4">
                                        <span class="seat_info_one_head ">
                                          Baggage:
                                        </span>
                                      </div>
                                      <div class="col-md-8" style="overflow:hidden;display:flex">
                                        <span class="seat_info_one">
                                          {{sector.baggageCheckIn}}
                                        </span>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-8">
                                        <span class="seat_info_one_head ">
                                          Baggage Charges:
                                        </span>
                                      </div>
                                      <div class="col-md-4">
                                        @if (bookingBaseData.supplierCode == 'SG') {
                                        <span class="seat_info_one">
                                          {{currency}} {{(sector.baggageFee * currencyRate)| number: '1.1-2'}}
                                        </span>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div style="width:70%;padding:6px;">
                                  <div class="meal_deatils_main">
                                    <div class="baggage_container">
                                      <div style="display:flex;flex-direction:column;">
                                        <span style="color:var(--first-color-second);font-weight:bold;">Checked Baggage</span>
                                        <span style="color:black;margin-bottom:4px;">It maybe  cheaper to book sufficient baggage allowance now than paying excess fee at the airport.</span>

                                        <span style="color: black; font-weight: bold; margin-bottom: 8px;">Pick your preferred weight</span>


                                      </div>
                                      <div class="cards_of_bagage">
                                        @if (bookingBaseData.supplierCode == 'SG') {
                                        <div class="row m-0 ">
                                          @for (baggagesector of baggageListJ; track baggagesector; let b = $index) {
                                          <div class="col-sm-4  baggage_container" style="margin-bottom: 4px;">
                                            <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
                                              <span style="color:var(--first-color-second);font-size:50px">
                                                <i class="fas fa-suitcase"></i>
                                              </span>
                                              <span class="bgag-name">
                                                {{baggagesector.PaxSSRPriceList[0].PaxFee.ServiceCharges[0].ChargeDetail}}({{baggagesector.SSRCode}}-KG)
                                              </span>
                                              <span style="color: var(--first-color-second); font-weight: bold; font-size: 14px; margin-bottom: 6px;">{{currency}} {{(baggagesector.PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount)| number: '1.1-2'}}</span>
                                              <button class="meal_button_add" id="baggageselectbtn{{i}}{{f}}{{b}}" (click)="spiceBaggageSelect(i,f,b)"><span id="baggageselectid{{i}}{{f}}{{b}}">Select</span></button>
                                            </div>

                                          </div>
                                          }

                                        </div>
                                        }

                                      </div>
                                    </div>
                                  </div>

                                </div>
                              </div>

                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                    <!--end baggage popup-->
                  </div>

                </div>
              </div>
            </div>
            }
          </div>
        </div>
        }


        <!--------------------------------------------------------------------------------------- spice ends --------------- -->
        @if ((airarbiaWithBaggage || fzAnxii || airIndiaWithBaggage) &&  obj.passengerType != 3) {
        <div class="Anci_mainClass">
          <div style="font-weight: bold; font-size: 18px; color: var(--first-color-second); padding: 5px; justify-content: center; display: flex; ">
            Extras
          </div>
          @for (sector of obj.sectorInformationProperties; track sector; let z = $index) {
          <div class="anci_section_main">
            <div class="row">
              <span class="sectorname">{{sector.fromAirport}} <i class="fas fa-plane-arrivals" style="margin-right:4px;margin-left:4px;color:black"></i> {{sector.toAirport}}</span>
            </div>
            <div class="anci_section_border">
              @if (bookingBaseData.supplierCode != 'FT' && bookingBaseData.supplierCode != '1GGDS'&& bookingBaseData.supplierCode != '1GNDC') {
              <div class="anci_Section_columns">
                <div class="anci_columns_head">
                  <div class="anci_columns_subhead">
                    <span class="anci_column_subject">Meal</span>
                    <span class="anci_column_name">{{sector.mealname}}</span>
                  </div>
                  <div style=" width: 10%">
                    @if (bookingBaseData.supplierCode != 'AI'&& bookingBaseData.supplierCode != 'J9'  && bookingBaseData.supplierCode != 'F3') {
                    <button class="anci_column_edit" (click)="mealopen(i,z,poperrornot)"><i class="fas fa-edit"></i></button>
                    }
                    @if ((bookingBaseData.supplierCode == 'AI' || bookingBaseData.supplierCode == 'J9' || bookingBaseData.supplierCode == 'F3') && sector.anciButton) {
                    <button class="anci_column_edit" (click)="mealopen(i,z,poperrornot)"><i class="fas fa-edit"></i></button>
                    }

                    <!--popup of meal-->
                    <div id="mealpopup{{i}}{{z}}" class="numofseatmodel">

                      <div class="modal modal-lg" tabindex="-1" role="dialog" style="max-width: 100% !important; ">
                        <div class="modal-dialog modal-lg " role="document" style="position: absolute; left: 250px;width:100%;">
                          <div class="modal-content" style="width:100% !important">
                            <div class="modal-header">
                              <div class="seat_model_header">
                                <span style="font-size: 20px; color: white; font-weight: bold; letter-spacing: 2px; ">Meal Selection</span>
                                <button style=" position: absolute; right: 16px; color: white; opacity: 1;" type="button" class="close" (click)="mealclose(i,z)" data-dismiss="modal" aria-label="Close">
                                  <span aria-hidden="true">&times;</span>
                                </button>
                              </div>
                            </div>

                            <div class="modal-body" style="padding: 0px !important;">
                              <div style="width:100%;">
                                <div style="width: 100%; padding: 6px;">
                                  <div class="mt-2 seat_info">
                                    <span class="seat_info_header" style="background-color: #39454B;">
                                      {{sector.fromAirport}} <i class="fas fa-plane-arrivals" style="margin-right:8px;margin-left:8px;color:white"></i> {{sector.toAirport}}
                                    </span>

                                    <div class="row">
                                      <div style="width:30%">
                                        <span class="seat_info_one_head ">
                                          Passenger Name:
                                        </span>
                                      </div>
                                      <div style="width:70%">
                                        <span class="seat_info_one">
                                          {{obj.title}} {{obj.firstName}} {{obj.lastName}}
                                        </span>
                                      </div>

                                    </div>
                                    <div class="row">

                                      <div style="width:30%">
                                        <span class="seat_info_one_head ">
                                          Meal Name:
                                        </span>
                                      </div>
                                      <div style="width: 70%; ">
                                        <span class="seat_info_one">
                                          {{sector.mealname}}
                                        </span>
                                      </div>

                                    </div>
                                    <div class="row">


                                      <div style="width:30%">
                                        <span class="seat_info_one_head ">
                                          Meal Charges:
                                        </span>
                                      </div>
                                      <div style="width:70%">
                                        @if (bookingBaseData.supplierCode == 'G9' || bookingBaseData.supplierCode == '3L' || bookingBaseData.supplierCode == '9P'||bookingBaseData.supplierCode == 'ONEAPI'|| bookingBaseData.supplierCode == 'AI'|| bookingBaseData.supplierCode == 'F3'|| bookingBaseData.supplierCode == 'QP' || bookingBaseData.supplierCode == 'XY') {
                                        <span class="seat_info_one">
                                          {{currency}} {{(sector.mealFee * currencyRate)| number: '1.1-2'}}
                                        </span>
                                        }
                                        @if (bookingBaseData.supplierCode == 'FZ') {
                                        <span class="seat_info_one">
                                          {{currency}} {{(sector.mealFee)| number: '1.1-2'}}
                                        </span>
                                        }
                                      </div>
                                    </div>


                                  </div>
                                </div>
                                @if (G93LMeals) {
                                <div style="width:100%;padding:6px;height:33rem;overflow:auto;">
                                  @for (mealsector of sector.mealListBysector; track mealsector; let m = $index) {
                                  <div class="meal_deatils_main">
                                    <div class="meal_Section">
                                      <div class="meal_section_one_image">
                                        <img style="height: 110px; width: 123px; background-size: contain; background-repeat: no-repeat; background-position: center; background-color: #fff;" src="{{mealsector.mealImage}}" />
                                      </div>
                                      <div class="meal_Section_deatils">
                                        <div class="meal_details_heading">
                                          <div class="meal_details_heading_section_one">
                                            <span style="font-weight:bold;font-size:18px;color:black;">{{mealsector.mealName}}</span>
                                            <span style="font-size:12px;color:black;">
                                              {{mealsector.mealDescription}}
                                            </span>
                                          </div>
                                          <div class="meal_details_heading_section_two" style="display:flex;justify-content:end">
                                            <span style="font-weight:bold;font-size:21px;">{{currency}} {{(mealsector.mealCharge* currencyRate)| number: '1.1-2'}}</span>
                                          </div>
                                        </div>
                                        <div class="meal_deatils_button">
                                          <button class="meal_button_add" id="mealselectbtn{{i}}{{z}}{{m}}" (click)="selectmeal(i,z,m)"><span id="mealselectid{{i}}{{z}}{{m}}">Select</span></button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  }

                                </div>
                                }
                                @if (FZMeals) {
                                <div style="width:100%;padding:6px;height:33rem;overflow:auto;">

                                  @for (mealsector of fzMealArray; track mealsector; let m = $index) {
                                  <div class="meal_deatils_main">
                                    <div class="meal_Section">
                                      <div class="meal_section_one_image">
                                        <img style="height: 110px; background-size: contain; background-repeat: no-repeat; background-position: center; background-color: #fff;" src="../../assets/img/foodicon.png" />
                                      </div>
                                      <div class="meal_Section_deatils">
                                        <div class="meal_details_heading">
                                          <div class="meal_details_heading_section_one">
                                            <span style="font-weight:bold;font-size:18px;color:black;">{{mealsector.description}}</span>
                                            <span style="font-size:12px;color:black;">
                                              {{mealsector.description}}
                                            </span>
                                          </div>
                                          <div class="meal_details_heading_section_two" style="display:flex;justify-content:end">
                                            <span style="font-weight: bold; font-size: 19px; color: orangered">{{currency}} {{(mealsector.amount * currencyRate)| number: '1.1-2'}}</span>
                                          </div>
                                        </div>
                                        <div class="meal_deatils_button">
                                          <button class="meal_button_add" id="mealselectbtn{{i}}{{z}}{{m}}" (click)="fzMealSelect(i,z,m)"><span id="mealselectid{{i}}{{z}}{{m}}">Select</span></button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  }
                                </div>
                                }
                              </div>

                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                    <!--end meal popup-->
                  </div>

                </div>
              </div>
              }

              <!--seat map of anci selectio -->
              @if (bookingBaseData.supplierCode == 'AI' || bookingBaseData.supplierCode == 'J9' || bookingBaseData.supplierCode == 'FT' || bookingBaseData.supplierCode == 'QP' || bookingBaseData.supplierCode == 'XY' || bookingBaseData.supplierCode == '1GGDS'|| bookingBaseData.supplierCode == '1GNDC' || bookingBaseData.supplierCode == 'F3') {
              <div class="anci_Section_columns" style="margin-left:0.4%">
                <div class="anci_columns_head">
                  <div class="anci_columns_subhead">
                    <span class="anci_column_subject">Seat</span>
                    <span class="anci_column_name">{{sector.seatNumber}}</span>
                  </div>
                  <div style=" width: 10%">

                    @if (sector.anciButton) {
                    <button class="anci_column_edit" (click)="seatMapopen(i,z)" id="seatselectid{{i}}{{z}}"><i class="fas fa-edit"></i></button>
                    }
                    <div id="newmodelofseat{{i}}{{z}}" class="numofseatmodel">
                      <div class="modal modal-lg" tabindex="-1" role="dialog" style="max-width: 100% !important; ">
                        <div class="modal-dialog modal-lg modal-dialog-centered" role="document" style="position: absolute; left: 250px;width:100%;">
                          <div class="modal-content" style="width:100% !important">
                            <div class="modal-header">
                              <div class="seat_model_header">
                                <span style="font-size: 20px; color: white; font-weight: bold; letter-spacing: 2px; ">Seat Selection</span>
                                <button style=" position: absolute; right: 16px; color: white; opacity: 1;" type="button" class="close" (click)="seatMapclose(i,z)" data-dismiss="modal" aria-label="Close">
                                  <span aria-hidden="true">&times;</span>
                                </button>
                              </div>



                            </div>
                            <div class="modal-body" style="padding: 0px !important;">
                              <div class="seat_model_body_one">
                                <div class="seat_model_body_two">
                                  <span class="seat_info_header">
                                    Seatmap Legend
                                  </span>
                                  <div class="row mb-2">
                                    <div class="col-md-3">
                                      <button class="square-skew " disabled>
                                        <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                        <!--<span class="tooltip-text" id="top{{k}}{{q}}">I'm a tooltip!</span>-->
                                      </button>
                                    </div>
                                    <div class="col-md-9">
                                      <span>Seat Available</span>
                                    </div>

                                  </div>

                                  <div class="row mb-2">
                                    <div class="col-md-3">


                                      <button class="square-skew_not not_avail_Seat" disabled>
                                        <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                        <!--<span class="tooltip-text" id="top{{k}}{{q}}">I'm a tooltip!</span>-->
                                      </button>
                                    </div>
                                    <div class="col-md-9">
                                      <span>Seat Unavailable</span>
                                    </div>

                                  </div>

                                  <div class="row mb-2">
                                    <div class="col-md-3">


                                      <button class="square-skew" style="background-color:var(--first-color-second)" disabled>
                                        <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                        <!--<span class="tooltip-text" id="top{{k}}{{q}}">I'm a tooltip!</span>-->
                                      </button>
                                    </div>
                                    <div class="col-md-9">
                                      <span>Seat Selected</span>
                                    </div>

                                  </div>
                                  <div class="row ">
                                    <div class="col-md-3">


                                      <button class="square-skew_not" style="background-color:orangered" disabled>
                                        <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                        <!--<span class="tooltip-text" id="top{{k}}{{q}}">I'm a tooltip!</span>-->
                                      </button>
                                    </div>
                                    <div class="col-md-9">
                                      <span>Seat Selected By Another Passenger</span>
                                    </div>

                                  </div>


                                </div>
                                <div class="mt-2 seat_info">
                                  <span class="seat_info_header">
                                    Seat Information
                                  </span>
                                  <span class="seat_info_header_sector">
                                    {{sector.fromAirport}} To {{sector.toAirport}}
                                  </span>
                                  <div class="row">
                                    <div class="col-md-4">
                                      <span class="seat_info_one_head ">
                                        Name:
                                      </span>
                                    </div>
                                    <div class="col-md-8" style="overflow:hidden;display:flex">
                                      <span class="seat_info_one">
                                        {{obj.firstName}}
                                      </span>
                                    </div>

                                  </div>
                                  <div class="row">
                                    <div class="col-md-4">
                                      <span class="seat_info_one_head ">
                                        Seat No:
                                      </span>
                                    </div>
                                    <div class="col-md-8">
                                      <span class="seat_info_one">
                                        {{sector.seatNumber}}
                                      </span>
                                    </div>

                                  </div>
                                  <div class="row">
                                    <div class="col-md-7">
                                      <span class="seat_info_one_head ">
                                        Seat Charges:
                                      </span>
                                    </div>
                                    <div class="col-md-5">
                                      <span class="seat_info_one">
                                        {{currency}} {{((sector.seatFee * currencyRate)| number: '1.1-2')}}
                                      </span>
                                    </div>

                                  </div>
                                </div>
                              </div>

                              <div class="seat_mdl_bdy_airone">
                                <div class="seat_mdl_bdy_airtwo">
                                  <div>
                                    <img class="seat_wing_one"
                                         src="data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMDAuNDMgMTQyLjA5Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZhMDt9LmNscy0ye2ZpbGw6IzAyMDAxNDt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjg3LjY0LDM1Ny41OWE3LDcsMCwwLDEtNi44Myw3LjE3aDBhNyw3LDAsMCwxLTcuMTctNi44NGwtLjkxLTM4LjE2YTcsNywwLDAsMSw2LjgzLTcuMThoMGE3LDcsMCwwLDEsNy4xOCw2Ljg1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIyMi4zMSAtMjIyLjY4KSIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTM0Mi41NCwzNDIuODhhNyw3LDAsMCwxLTYuODQsNy4xN2gwYTcsNywwLDAsMS03LjE3LTYuODRsLS45MS0zOC4xNmE3LDcsMCwwLDEsNi44NC03LjE4aDBhNyw3LDAsMCwxLDcuMTcsNi44NFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMjIuMzEgLTIyMi42OCkiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0zOTcuNDMsMzI4LjE2YTcsNywwLDAsMS02Ljg0LDcuMThoMGE3LDcsMCwwLDEtNy4xOC02Ljg0bC0uOTEtMzguMTZhNyw3LDAsMCwxLDYuODUtNy4xOGgwYTcsNywwLDAsMSw3LjE4LDYuODVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzA0Ljc3LDI0OC43OWwuNTQsMjIuODdhMTMuNzksMTMuNzksMCwwLDAsNi4wNywxMS4wOWw3LjY1LDUuMTcsMTMuMTEtOS43OC0uNzItMzBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzU0LjMxLDIyMy4zMWwuNTQsMjIuODhhMTMuNzksMTMuNzksMCwwLDAsNi4wNywxMS4wOWw3LjY1LDUuMTYsMTMuMS05Ljc4LS43MS0zMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMjIuMzEgLTIyMi42OCkiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik00MjAuNzEsMjIyLjcxbDIsODUuMjItMzYuMjguODdMMjIyLjMxLDM1NS42OWMyLjg5LTIwLDIuMTUtMzIuMDcsMTUuMTUtMzguNzVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PC9zdmc+">
                                  </div>
                                  <div class="aircraft">
                                    <div>
                                      <div class="aircraft-head">
                                        <!-- <div class="aircraft-head_inner"> -->
                                        <img class="pt32-w80"
                                             src="data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNTYuNDUgMTUzLjUzIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzAyMDAxNDt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNjM1LjQsNzNzLTI5LjI3LDYuMTMtNDcuNjYsNDdMNTk4LDE0NS41M3MyMC40Mi0yOC45MywzNy40NC0yOC45M1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01NjAuMzQgLTczLjAxKSIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTY0MC41MSw3M3Y0Mi41NWE2MC41Nyw2MC41NywwLDAsMSwzNy40NSwzMGwxMS4yMy0yNi4yMVM2NjMuNjYsNzIuMzQsNjQwLjUxLDczWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU2MC4zNCAtNzMuMDEpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNTg1LjcsMTI1Ljc5bDkuODcsMjQuNTFTNTgyLDE3MS43NCw1NzkuOTEsMTg2LjM4bC0xMi41OS05Ljg3UzU3NS44MywxMzguMzgsNTg1LjcsMTI1Ljc5WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU2MC4zNCAtNzMuMDEpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNjkxLjIzLDEyNC4wOWwtOS44NywyNS4xOXMxMy4yOCwyMS43OCwxNiwzNy4xbDExLjkyLTEwLjg5UzcwMy40OSwxNDUsNjkxLjIzLDEyNC4wOVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01NjAuMzQgLTczLjAxKSIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTU2NS43OSwxODEuNzksNTc3LjUzLDE5MmwtNC45MywyOS40NXMtOS44OCwxMi4wOC0xMi4yNi0zLjI0WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU2MC4zNCAtNzMuMDEpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNjk5LjQsMTkxLjMybDExLjA3LTkuNTNzNi44MSwzMS4xNSw2LjMsMzcuNzhjMCwwLTMuMDcsMTUtMTIuNiwxWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU2MC4zNCAtNzMuMDEpIi8+PC9zdmc+">
                                      </div>
                                      <div class="aircraft-body-exit-top">
                                        <div class="aircraft-body-exit-left-top">
                                        </div>
                                        <div class="aircraft-body-exit-top-center">
                                        </div>
                                        <div class="aircraft-body-exit-right-top">
                                        </div>
                                      </div>
                                      <div class="aircraft-body-exit">
                                        <div class="aircraft-body-exit-left">
                                        </div>
                                        <div class="aircraft-body-exit-right">
                                        </div>
                                      </div>
                                      <div class="aircraft-body-exit-top">
                                        <div class="aircraft-body-exit-left-top">
                                        </div>
                                        <div class="aircraft-body-exit-top-center">
                                        </div>
                                        <div class="aircraft-body-exit-right-top">
                                        </div>
                                      </div>
                                      <div class="aircraft-body-rowClass">
                                        <div class="aircraft-row-innner-body">
                                          @if (sector.seatListBysectorResponsive != null) {
                                          <div class="aircraft_inner_divone">
                                            @if (sector.seatListBysectorResponsive.executiveSeatAvail) {
                                            <div>
                                              <div class="execRows">
                                                Executive
                                              </div>
                                              <div class="aircraft_inner_divtwo" style="display:flex;justify-content:center;align-items:center;font-weight:bold">
                                                @for (rowssection of sector.seatListBysectorResponsive.dynamicSeatsWithRowsExec.seatSection ; track rowssection; let yu = $index) {
                                                <span>
                                                  @if (rowssection!='X') {
                                                  <span style="padding:0px 2px 0px 2px">{{rowssection}}</span>
                                                  }
                                                  @if (rowssection=='X') {
                                                  <span style="padding:0px 4px 0px 4px"></span>
                                                  }
                                                </span>
                                                }
                                              </div>
                                              @for (rowsexec of sector.seatListBysectorResponsive.dynamicSeatsWithRowsExec.rows ; track rowsexec; let p = $index) {
                                              <div class="aircraft_inner_divtwo" style="justify-content:center">
                                                @for (seatobjexec of rowsexec.seats; track seatobjexec; let q = $index) {
                                                <div>
                                                  @if (seatobjexec.seatStatus == 'Availiable') {
                                                  <button class="square-skew hover-text"
                                                          (click)="seatselectedsectorAirIndia(i,z,p,q,'EXECUTIVE')"
                                                          id="link3buttonexec{{i}}{{z}}{{p}}{{q}}">
                                                    <span class="tooltip-text"
                                                          id="tops{{p}}{{q}}">
                                                      Seat
                                                      Charge:{{currency}}
                                                      {{(seatobjexec.seatCharge)}}
                                                    </span>
                                                    <img class="imageofseats"
                                                         src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />

                                                  </button>
                                                  }
                                                  @if (seatobjexec.seatStatus == 'EMPTY' ) {
                                                  <button class="square-skew_not_EMPTY"
                                                          disabled
                                                          id="link3exec{{p}}{{q}}">
                                                    <img class="imageofseats"
                                                         src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />

                                                  </button>
                                                  }
                                                  @if (seatobjexec.seatStatus == 'NonAvailiable' ) {
                                                  <button class="square-skew_not not_avail_Seat"
                                                          disabled
                                                          id="link3exec{{p}}{{q}}">
                                                    <img class="imageofseats"
                                                         src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                                  </button>
                                                  }
                                                  @if (seatobjexec.seatStatus == 'RSP') {
                                                  <button class="square-skew_not"
                                                          style="background-color:orangered;cursor:not-allowed"
                                                          disabled
                                                          id="link3exec{{p}}{{q}}">
                                                    <img class="imageofseats"
                                                         src="data:image/png;base64k,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                                  </button>
                                                  }
                                                  @if (seatobjexec.seatStatus == 'AISLE') {
                                                  <button style="border:none;color:var(--first-color-second);"
                                                          disabled
                                                          id="link3exec{{p}}{{q}}">
                                                    {{rowsexec.rowNumber}}
                                                  </button>
                                                  }
                                                </div>
                                                }
                                              </div>
                                              }
                                            </div>
                                            }
                                            @if (sector.seatListBysectorResponsive.economySeatAvail) {
                                            <div>
                                              <div class="execRows">
                                                Economy
                                              </div>
                                              <div class="aircraft_inner_divtwo" style="display:flex;justify-content:center;align-items:center;font-weight:bold">
                                                @for (rowssection of sector.seatListBysectorResponsive.dynamicSeatsWithRowsEco.seatSection ; track rowssection; let yu = $index) {
                                                <span>
                                                  @if (rowssection!='X') {
                                                  <span style="padding:0px 2px 0px 2px">{{rowssection}}</span>
                                                  }
                                                  @if (rowssection=='X') {
                                                  <span style="padding:0px 4px 0px 4px"></span>
                                                  }
                                                </span>
                                                }
                                              </div>
                                              @for (rows of sector.seatListBysectorResponsive.dynamicSeatsWithRowsEco.rows; track rows; let k = $index) {
                                              <div class="aircraft_inner_divtwo">
                                                @for (seatobj of rows.seats; track seatobj; let q = $index) {
                                                <div>
                                                  @if (seatobj.seatStatus == 'EMPTY' ) {
                                                  <button class="square-skew_not_EMPTY"
                                                          disabled>
                                                    <img class="imageofseats"
                                                         src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />

                                                  </button>
                                                  }
                                                  @if (seatobj.seatStatus == 'Availiable') {
                                                  <button class="square-skew hover-text"
                                                          (click)="seatselectedsectorAirIndia(i,z,k,q,'Economy')"
                                                          id="link3button{{i}}{{z}}{{k}}{{q}}">
                                                    <span class="tooltip-text">
                                                      Seat
                                                      Charge:{{currency}}<span id="top{{k}}{{q}}">{{(seatobj.seatCharge)}}</span>
                                                    </span>
                                                    <img class="imageofseats"
                                                         src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />

                                                  </button>
                                                  }
                                                  @if (seatobj.seatStatus == 'NonAvailiable' ) {
                                                  <button class="square-skew_not not_avail_Seat"
                                                          disabled
                                                          id="link3{{k}}{{q}}">
                                                    <img class="imageofseats"
                                                         src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                                  </button>
                                                  }
                                                  @if (seatobj.seatStatus == 'RSP') {
                                                  <button class="square-skew_not"
                                                          style="background-color:orangered;cursor:not-allowed"
                                                          disabled
                                                          id="link3{{k}}{{q}}">
                                                    <img class="imageofseats"
                                                         src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                                  </button>
                                                  }
                                                  @if (seatobj.seatStatus == 'AISLE') {
                                                  <button style="border:none;color:var(--first-color-second);"
                                                          disabled>
                                                    {{rows.rowNumber}}
                                                  </button>
                                                  }
                                                </div>
                                                }
                                              </div>
                                              }
                                            </div>
                                            }

                                          </div>
                                          }

                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div>
                                    <img style="width: 207px; margin-left: -2px; margin-top: 163px;" src="data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMDAuNDMgMTQyLjA5Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZhMDt9LmNscy0ye2ZpbGw6IzAyMDAxNDt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzU3LjQxLDM1Ny41OWE3LDcsMCwwLDAsNi44Myw3LjE3aDBhNyw3LDAsMCwwLDcuMTctNi44NGwuOTEtMzguMTZhNyw3LDAsMCwwLTYuODMtNy4xOGgwYTcsNywwLDAsMC03LjE4LDYuODVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzAyLjUxLDM0Mi44OGE3LDcsMCwwLDAsNi44NCw3LjE3aDBhNyw3LDAsMCwwLDcuMTctNi44NGwuOTEtMzguMTZhNyw3LDAsMCwwLTYuODQtNy4xOGgwYTcsNywwLDAsMC03LjE3LDYuODRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjQ3LjYxLDMyOC4xNmE3LDcsMCwwLDAsNi44NSw3LjE4aDBhNyw3LDAsMCwwLDcuMTgtNi44NGwuOTEtMzguMTZhNyw3LDAsMCwwLTYuODUtNy4xOGgwYTcsNywwLDAsMC03LjE4LDYuODVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzQwLjI4LDI0OC43OWwtLjU1LDIyLjg3YTEzLjc2LDEzLjc2LDAsMCwxLTYuMDYsMTEuMDlMMzI2LDI4Ny45MmwtMTMuMTEtOS43OC43Mi0zMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMjIuMzEgLTIyMi42OCkiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0yOTAuNzQsMjIzLjMxbC0uNTQsMjIuODhhMTMuODIsMTMuODIsMCwwLDEtNi4wNywxMS4wOWwtNy42NSw1LjE2LTEzLjExLTkuNzguNzItMzBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMjI0LjM0LDIyMi43MWwtMiw4NS4yMiwzNi4yOC44NywxNjQuMTUsNDYuODljLTIuODktMjAtMi4xNS0zMi4wNy0xNS4xNS0zOC43NVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMjIuMzEgLTIyMi42OCkiLz48L3N2Zz4=">
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>





                    </div>

                  </div>

                </div>
              </div>
              }

              @if (this.bookingBaseData.supplierCode == 'G9' || this.bookingBaseData.supplierCode == '3L' || this.bookingBaseData.supplierCode == 'FZ' || bookingBaseData.supplierCode == '9P'||bookingBaseData.supplierCode == 'ONEAPI') {
              <div class="anci_Section_columns" style="margin-left:0.4%">
                <div class="anci_columns_head">
                  <div class="anci_columns_subhead">
                    <span class="anci_column_subject">Seat</span>
                    <span class="anci_column_name">{{sector.seatNumber}}</span>
                  </div>
                  <div style=" width: 10%">
                    <button class="anci_column_edit" (click)="seatMapopen(i,z)" id="seatselectid{{i}}{{z}}"><i class="fas fa-edit"></i></button>
                    <div id="newmodelofseat{{i}}{{z}}" class="numofseatmodel">
                      <div class="modal modal-lg" tabindex="-1" role="dialog" style="max-width: 100% !important; ">
                        <div class="modal-dialog modal-lg modal-dialog-centered" role="document" style="position: absolute; left: 250px;width:100%;">
                          <div class="modal-content" style="width:100% !important">
                            <div class="modal-header">
                              <div class="seat_model_header">
                                <span style="font-size: 20px; color: white; font-weight: bold; letter-spacing: 2px; ">Seat Selection</span>
                                <button style=" position: absolute; right: 16px; color: white; opacity: 1;" type="button" class="close" (click)="seatMapclose(i,z)" data-dismiss="modal" aria-label="Close">
                                  <span aria-hidden="true">&times;</span>
                                </button>
                              </div>



                            </div>
                            <div class="modal-body" style="padding: 0px !important;">
                              <div class="seat_model_body_one">
                                <div class="seat_model_body_two">
                                  <span class="seat_info_header">
                                    Seatmap Legend
                                  </span>
                                  <div class="row mb-2">
                                    <div class="col-md-3">
                                      <button class="square-skew " disabled>
                                        <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                        <!--<span class="tooltip-text" id="top{{k}}{{q}}">I'm a tooltip!</span>-->
                                      </button>
                                    </div>
                                    <div class="col-md-9">
                                      <span>Seat Available</span>
                                    </div>

                                  </div>

                                  <div class="row mb-2">
                                    <div class="col-md-3">


                                      <button class="square-skew_not not_avail_Seat" disabled>
                                        <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                        <!--<span class="tooltip-text" id="top{{k}}{{q}}">I'm a tooltip!</span>-->
                                      </button>
                                    </div>
                                    <div class="col-md-9">
                                      <span>Seat Unavailable</span>
                                    </div>

                                  </div>

                                  <div class="row mb-2">
                                    <div class="col-md-3">


                                      <button class="square-skew" style="background-color:var(--first-color-second)" disabled>
                                        <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                        <!--<span class="tooltip-text" id="top{{k}}{{q}}">I'm a tooltip!</span>-->
                                      </button>
                                    </div>
                                    <div class="col-md-9">
                                      <span>Seat Selected</span>
                                    </div>

                                  </div>
                                  <div class="row ">
                                    <div class="col-md-3">


                                      <button class="square-skew_not" style="background-color:orangered" disabled>
                                        <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                        <!--<span class="tooltip-text" id="top{{k}}{{q}}">I'm a tooltip!</span>-->
                                      </button>
                                    </div>
                                    <div class="col-md-9">
                                      <span>Seat Selected By Another Passenger</span>
                                    </div>

                                  </div>


                                </div>
                                <div class="mt-2 seat_info">
                                  <span class="seat_info_header">
                                    Seat Information
                                  </span>
                                  <span class="seat_info_header_sector">
                                    {{sector.fromAirport}} To {{sector.toAirport}}
                                  </span>
                                  <div class="row">
                                    <div class="col-md-4">
                                      <span class="seat_info_one_head ">
                                        Name:
                                      </span>
                                    </div>
                                    <div class="col-md-8" style="overflow:hidden;display:flex">
                                      <span class="seat_info_one">
                                        {{obj.firstName}}
                                      </span>
                                    </div>

                                  </div>
                                  <div class="row">
                                    <div class="col-md-4">
                                      <span class="seat_info_one_head ">
                                        Seat No:
                                      </span>
                                    </div>
                                    <div class="col-md-8">
                                      <span class="seat_info_one">
                                        {{sector.seatNumber}}
                                      </span>
                                    </div>

                                  </div>
                                  <div class="row">
                                    <div class="col-md-7">
                                      <span class="seat_info_one_head ">
                                        Seat Charges:
                                      </span>
                                    </div>
                                    <div class="col-md-5">
                                      <span class="seat_info_one">
                                        {{currency}} {{((sector.seatFee * currencyRate)| number: '1.1-2')}}
                                      </span>
                                    </div>

                                  </div>
                                </div>
                              </div>
                              <div class="seat_mdl_bdy_airone">
                                <div class="seat_mdl_bdy_airtwo">
                                  <div>
                                    <img class="seat_wing_one" src="data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMDAuNDMgMTQyLjA5Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZhMDt9LmNscy0ye2ZpbGw6IzAyMDAxNDt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjg3LjY0LDM1Ny41OWE3LDcsMCwwLDEtNi44Myw3LjE3aDBhNyw3LDAsMCwxLTcuMTctNi44NGwtLjkxLTM4LjE2YTcsNywwLDAsMSw2LjgzLTcuMThoMGE3LDcsMCwwLDEsNy4xOCw2Ljg1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIyMi4zMSAtMjIyLjY4KSIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTM0Mi41NCwzNDIuODhhNyw3LDAsMCwxLTYuODQsNy4xN2gwYTcsNywwLDAsMS03LjE3LTYuODRsLS45MS0zOC4xNmE3LDcsMCwwLDEsNi44NC03LjE4aDBhNyw3LDAsMCwxLDcuMTcsNi44NFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMjIuMzEgLTIyMi42OCkiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0zOTcuNDMsMzI4LjE2YTcsNywwLDAsMS02Ljg0LDcuMThoMGE3LDcsMCwwLDEtNy4xOC02Ljg0bC0uOTEtMzguMTZhNyw3LDAsMCwxLDYuODUtNy4xOGgwYTcsNywwLDAsMSw3LjE4LDYuODVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzA0Ljc3LDI0OC43OWwuNTQsMjIuODdhMTMuNzksMTMuNzksMCwwLDAsNi4wNywxMS4wOWw3LjY1LDUuMTcsMTMuMTEtOS43OC0uNzItMzBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzU0LjMxLDIyMy4zMWwuNTQsMjIuODhhMTMuNzksMTMuNzksMCwwLDAsNi4wNywxMS4wOWw3LjY1LDUuMTYsMTMuMS05Ljc4LS43MS0zMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMjIuMzEgLTIyMi42OCkiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik00MjAuNzEsMjIyLjcxbDIsODUuMjItMzYuMjguODdMMjIyLjMxLDM1NS42OWMyLjg5LTIwLDIuMTUtMzIuMDcsMTUuMTUtMzguNzVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PC9zdmc+">
                                  </div>

                                  <div class="aircraft">
                                    <div class="aircraft-head">
                                      <!-- <div class="aircraft-head_inner"> -->
                                      <img style="width: 180px; padding-top: 32px;"
                                           src="data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNTYuNDUgMTUzLjUzIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzAyMDAxNDt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNjM1LjQsNzNzLTI5LjI3LDYuMTMtNDcuNjYsNDdMNTk4LDE0NS41M3MyMC40Mi0yOC45MywzNy40NC0yOC45M1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01NjAuMzQgLTczLjAxKSIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTY0MC41MSw3M3Y0Mi41NWE2MC41Nyw2MC41NywwLDAsMSwzNy40NSwzMGwxMS4yMy0yNi4yMVM2NjMuNjYsNzIuMzQsNjQwLjUxLDczWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU2MC4zNCAtNzMuMDEpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNTg1LjcsMTI1Ljc5bDkuODcsMjQuNTFTNTgyLDE3MS43NCw1NzkuOTEsMTg2LjM4bC0xMi41OS05Ljg3UzU3NS44MywxMzguMzgsNTg1LjcsMTI1Ljc5WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU2MC4zNCAtNzMuMDEpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNjkxLjIzLDEyNC4wOWwtOS44NywyNS4xOXMxMy4yOCwyMS43OCwxNiwzNy4xbDExLjkyLTEwLjg5UzcwMy40OSwxNDUsNjkxLjIzLDEyNC4wOVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01NjAuMzQgLTczLjAxKSIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTU2NS43OSwxODEuNzksNTc3LjUzLDE5MmwtNC45MywyOS40NXMtOS44OCwxMi4wOC0xMi4yNi0zLjI0WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU2MC4zNCAtNzMuMDEpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNjk5LjQsMTkxLjMybDExLjA3LTkuNTNzNi44MSwzMS4xNSw2LjMsMzcuNzhjMCwwLTMuMDcsMTUtMTIuNiwxWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU2MC4zNCAtNzMuMDEpIi8+PC9zdmc+">
                                      <!-- </div> -->
                                    </div>
                                    <div class="aircraft-body-exit-top">
                                      <div class="aircraft-body-exit-left-top">
                                      </div>
                                      <div class="aircraft-body-exit-top-center">
                                      </div>
                                      <div class="aircraft-body-exit-right-top">
                                      </div>
                                    </div>
                                    <div class="aircraft-body-exit">
                                      <div class="aircraft-body-exit-left">
                                        <div class="aircraft-inner-rowclass">
                                          <span>A</span>
                                          <span>B</span>
                                          <span>C</span>
                                        </div>
                                      </div>
                                      <div class="aircraft-body-exit-right">
                                        <div class="aircraft-inner-rowclass">
                                          <span>D</span>
                                          <span>E</span>
                                          <span>F</span>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="aircraft-body-exit-top">
                                      <div class="aircraft-body-exit-left-top">
                                      </div>
                                      <div class="aircraft-body-exit-top-center">
                                      </div>
                                      <div class="aircraft-body-exit-right-top">
                                      </div>
                                    </div>
                                    <div class="aircraft-body-rowClass">
                                      <div class="aircraft-row-innner-body">
                                        <div class="aircraft_inner_divone">
                                          @for (rows of sector.seatListBysector; track rows; let k = $index) {
                                          <div class="aircraft_inner_divtwo">
                                            @for (seatobj of rows.seats; track seatobj; let q = $index) {
                                            <div>
                                              @if (seatobj.seatStatus == 'VAC' ) {
                                              <button class="square-skew hover-text" (click)="seatselectedsector(i,z,k,q)" id="link3button{{i}}{{z}}{{k}}{{q}}">
                                                <span class="tooltip-text" id="top{{k}}{{q}}">Seat Charge:{{currency}} {{(seatobj.seatCharge * currencyRate)| number: '1.1-2'}}</span>
                                                <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />

                                              </button>
                                              }

                                              @if (seatobj.seatStatus == 'RES' || seatobj.seatStatus == 'INA' ) {
                                              <button class="square-skew_not not_avail_Seat" disabled id="link3{{k}}{{q}}">
                                                <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                                <!--<span class="tooltip-text" id="top{{k}}{{q}}">I'm a tooltip!</span>-->
                                              </button>
                                              }
                                              @if (seatobj.seatStatus == 'RSP' ) {
                                              <button class="square-skew_not" style="background-color:orangered;cursor:not-allowed" disabled id="link3{{k}}{{q}}">
                                                <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                                <!--<span class="tooltip-text" id="top{{k}}{{q}}">I'm a tooltip!</span>-->
                                              </button>
                                              }
                                              @if ((q==2)) {
                                              <button id="link3{{k}}{{q}}" class="aircraft_inner_res">
                                                {{rows.rowNumber}}
                                              </button>
                                              }

                                            </div>
                                            }


                                          </div>
                                          }



                                        </div>

                                      </div>
                                    </div>

                                    <!-- <div class="aircraft-bottom-wing">
                                <div class="exists">
                                  <div><img src="https://i.ibb.co/ftwgLCL/exist.png"></div>
                                  <div><img src="https://i.ibb.co/ftwgLCL/exist.png"></div>
                                </div>
                              </div> -->
                                  </div>
                                  <div>
                                    <img style="width: 207px; margin-left: -2px; margin-top: 163px;" src="data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMDAuNDMgMTQyLjA5Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZhMDt9LmNscy0ye2ZpbGw6IzAyMDAxNDt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzU3LjQxLDM1Ny41OWE3LDcsMCwwLDAsNi44Myw3LjE3aDBhNyw3LDAsMCwwLDcuMTctNi44NGwuOTEtMzguMTZhNyw3LDAsMCwwLTYuODMtNy4xOGgwYTcsNywwLDAsMC03LjE4LDYuODVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzAyLjUxLDM0Mi44OGE3LDcsMCwwLDAsNi44NCw3LjE3aDBhNyw3LDAsMCwwLDcuMTctNi44NGwuOTEtMzguMTZhNyw3LDAsMCwwLTYuODQtNy4xOGgwYTcsNywwLDAsMC03LjE3LDYuODRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjQ3LjYxLDMyOC4xNmE3LDcsMCwwLDAsNi44NSw3LjE4aDBhNyw3LDAsMCwwLDcuMTgtNi44NGwuOTEtMzguMTZhNyw3LDAsMCwwLTYuODUtNy4xOGgwYTcsNywwLDAsMC03LjE4LDYuODVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzQwLjI4LDI0OC43OWwtLjU1LDIyLjg3YTEzLjc2LDEzLjc2LDAsMCwxLTYuMDYsMTEuMDlMMzI2LDI4Ny45MmwtMTMuMTEtOS43OC43Mi0zMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMjIuMzEgLTIyMi42OCkiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0yOTAuNzQsMjIzLjMxbC0uNTQsMjIuODhhMTMuODIsMTMuODIsMCwwLDEtNi4wNywxMS4wOWwtNy42NSw1LjE2LTEzLjExLTkuNzguNzItMzBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMjI0LjM0LDIyMi43MWwtMiw4NS4yMiwzNi4yOC44NywxNjQuMTUsNDYuODljLTIuODktMjAtMi4xNS0zMi4wNy0xNS4xNS0zOC43NVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMjIuMzEgLTIyMi42OCkiLz48L3N2Zz4=">
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>





                    </div>

                  </div>

                </div>
              </div>
              }
              <div class="anci_Section_columns" style="margin-left:0.4%">
                <div class="anci_columns_head">
                  <div class="anci_columns_subhead">
                    <span class="anci_column_subject">Baggage</span>
                    <span class="anci_column_name">{{sector.baggageCheckIn}}</span>
                  </div>
                  <div style=" width: 10%">
                    <!--airarabia-->
                    @if (bookingBaseData.supplierCode == 'G9'|| bookingBaseData.supplierCode == 'J9' || bookingBaseData.supplierCode == 'F3' || bookingBaseData.supplierCode == '3L' || bookingBaseData.supplierCode == '9P'||bookingBaseData.supplierCode == 'ONEAPI'||  bookingBaseData.supplierCode == 'AI'|| bookingBaseData.supplierCode == 'FT' || bookingBaseData.supplierCode == 'QP' || bookingBaseData.supplierCode == 'XY') {
                    <div>
                      @if (sector.baggagebtn) {
                      <button class="anci_column_edit" (click)="baggageopen(i,z)"><i class="fas fa-edit"></i></button>
                      }
                    </div>
                    }
                    <!--flydubai-->
                    @if (bookingBaseData.supplierCode == 'FZ') {
                    <div>
                      @if (sector.baggagebtn) {
                      <button class="anci_column_edit" (click)="fzBaggageClick(i,z,poperrornot)"><i class="fas fa-edit"></i></button>
                      }
                    </div>
                    }



                    <!--popup of meal-->
                    <div id="baggagepopup{{i}}{{z}}" class="numofseatmodel">


                      <div class="modal modal-lg" tabindex="-1" role="dialog" style="max-width: 100% !important; ">
                        <div class="modal-dialog modal-lg " role="document" style="position: absolute; left: 250px;width:100%;">
                          <div class="modal-content" style="width:100% !important">
                            <div class="modal-header">
                              <div class="seat_model_header">
                                <span style="font-size: 20px; color: white; font-weight: bold; letter-spacing: 2px; ">Baggage Selection</span>
                                <button style=" position: absolute; right: 16px; color: white; opacity: 1;" type="button" class="close" (click)="baggageclose(i,z)" data-dismiss="modal" aria-label="Close">
                                  <span aria-hidden="true">&times;</span>
                                </button>
                              </div>
                            </div>

                            <div class="modal-body" style="padding: 0px !important;">
                              <div style="width:100%;display:flex;">
                                <div style="width:30%;padding:6px;">
                                  <div class="mt-2 seat_info">
                                    <span class="seat_info_header">
                                      Baggage Information
                                    </span>
                                    <span class="seat_info_header_sector">
                                      {{sector.fromAirport}} To {{sector.toAirport}}
                                    </span>
                                    <div class="row">
                                      <div class="col-md-4">
                                        <span class="seat_info_one_head ">
                                          Name:
                                        </span>
                                      </div>
                                      <div class="col-md-8" style="overflow:hidden;display:flex">
                                        <span class="seat_info_one">
                                          {{obj.firstName}}
                                        </span>
                                      </div>

                                    </div>
                                    <div class="row">
                                      <div class="col-md-4">
                                        <span class="seat_info_one_head ">
                                          Baggage:
                                        </span>
                                      </div>
                                      <div class="col-md-8" style="overflow:hidden;display:flex">
                                        <span class="seat_info_one">
                                          {{sector.baggageCheckIn}}
                                        </span>
                                      </div>

                                    </div>
                                    <div class="row">
                                      <div class="col-md-8">
                                        <span class="seat_info_one_head ">
                                          Baggage Charges:
                                        </span>
                                      </div>
                                      <div class="col-md-4">
                                        @if (bookingBaseData.supplierCode == 'G9'||  bookingBaseData.supplierCode == 'AI' || bookingBaseData.supplierCode == 'F3' || bookingBaseData.supplierCode == 'J9' || bookingBaseData.supplierCode == '3L' || bookingBaseData.supplierCode == '9P'||bookingBaseData.supplierCode == 'ONEAPI'|| bookingBaseData.supplierCode == 'FT'|| bookingBaseData.supplierCode == 'QP' || bookingBaseData.supplier == 'XY') {
                                        <span class="seat_info_one">
                                          {{currency}} {{(sector.baggageFee * currencyRate)| number: '1.1-2'}}
                                        </span>
                                        }
                                        @if (bookingBaseData.supplierCode == 'FZ') {
                                        <span class="seat_info_one">
                                          {{currency}} {{(sector.baggageFee)| number: '1.1-2'}}
                                        </span>
                                        }
                                      </div>

                                    </div>
                                  </div>
                                </div>
                                <div style="width:70%;padding:6px;">
                                  <div class="meal_deatils_main">
                                    <div class="baggage_container">
                                      <div style="display:flex;flex-direction:column;">
                                        <span style="color:var(--first-color-second);font-weight:bold;">Checked Baggage</span>
                                        <span style="color:black;margin-bottom:4px;">It maybe  cheaper to book sufficient baggage allowance now than paying excess fee at the airport.</span>

                                        <span style="color: black; font-weight: bold; margin-bottom: 8px;">Pick your preferred weight</span>
                                        @if (bookingBaseData.supplierCode == 'AI' || bookingBaseData.supplierCode == 'J9' || bookingBaseData.supplierCode == 'F3') {
                                        <div style="text-align: center;">
                                          <span style="font-size:12px;color:var(--first-color-second)">Your Free Baggage Allownce: {{sector.extraBagCheckIn}}</span>
                                        </div>
                                        }

                                      </div>
                                      <div class="cards_of_bagage">
                                        @if (bookingBaseData.supplierCode == 'G9' || bookingBaseData.supplierCode == 'J9' || bookingBaseData.supplierCode == 'F3' ||  bookingBaseData.supplierCode == '3L'||  bookingBaseData.supplierCode == 'AI' || bookingBaseData.supplierCode == '9P' ||  bookingBaseData.supplierCode == 'ONEAPI'|| bookingBaseData.supplierCode == 'FT' || bookingBaseData.supplierCode == 'QP' || bookingBaseData.supplierCode == 'XY') {
                                        <div class="row m-0 ">
                                          @for (baggagesector of sector.baggaesBysector; track baggagesector; let b = $index) {
                                          <div class="col-sm-4  baggage_container" style="margin-bottom: 4px;">
                                            <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
                                              <span style="color:var(--first-color-second);font-size:50px">
                                                <i class="fas fa-suitcase"></i>
                                              </span>
                                              @if (bookingBaseData.supplierCode == 'AI' || bookingBaseData.supplierCode == 'J9'|| bookingBaseData.supplierCode == 'FT' || bookingBaseData.supplierCode == 'F3') {
                                              <span style="color: black; font-weight: bold; font-size: 14px; margin-bottom: 6px;">
                                                {{baggagesector.baggageDescription}}
                                              </span>
                                              }
                                              @if (bookingBaseData.supplierCode != 'AI'  && bookingBaseData.supplierCode != 'J9' && bookingBaseData.supplierCode != 'F3') {
                                              <span style="color: black; font-weight: bold; font-size: 14px; margin-bottom: 6px;">
                                                {{baggagesector.baggageCode}}
                                              </span>
                                              }
                                              <span style="color: var(--first-color-second); font-weight: bold; font-size: 14px; margin-bottom: 6px;">{{currency}} {{(baggagesector.baggageCharge * currencyRate)| number: '1.1-2'}}</span>
                                              <button class="meal_button_add" id="baggageselectbtn{{i}}{{z}}{{b}}" (click)="baggageselect(i,z,b)"><span id="baggageselectid{{i}}{{z}}{{b}}">Select</span></button>
                                            </div>

                                          </div>
                                          }

                                        </div>
                                        }
                                        @if (bookingBaseData.supplierCode == 'FZ') {
                                        <div class="row m-0 ">
                                          @for (baggagesector of fzBaggageArray; track baggagesector; let b = $index) {
                                          <div class="col-sm-4  baggage_container" style="margin-bottom: 4px;">
                                            <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
                                              <span style="color:var(--first-color-second);font-size:50px">
                                                <i class="fas fa-suitcase"></i>
                                              </span>
                                              <span style="color: black; font-weight: bold; font-size: 14px; margin-bottom: 6px;padding-left:14px;">
                                                {{baggagesector.description}}
                                              </span>
                                              <span style="color: var(--first-color-second); font-weight: bold; font-size: 14px; margin-bottom: 6px;">{{currency}} {{(baggagesector.amount * currencyRate) | number: '1.1-2'}}</span>
                                              <button class="meal_button_add" id="baggageselectbtn{{i}}{{z}}{{b}}" (click)="fzBaggageSelect(i,z,b)"><span id="baggageselectid{{i}}{{z}}{{b}}">Select</span></button>
                                            </div>

                                          </div>
                                          }

                                        </div>
                                        }
                                      </div>
                                    </div>
                                  </div>

                                </div>
                              </div>

                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                    <!--end meal popup-->
                  </div>

                </div>
              </div>
            </div>
            <div class="row">
              <div class="çol-md-4">
                <span class="first-required" id="mealselectmessage{{i}}{{z}}"></span>
              </div>
              <div class="çol-md-4">
                <span class="first-required" id="seatselectmessage{{i}}{{z}}"></span>
              </div>
              <div class="çol-md-4">
                <span class="first-required" id="baggageselectmessage{{i}}{{z}}"></span>
              </div>
            </div>
          </div>
          }

        </div>
        }

      </div>
        </div>
}

        <!----<div class="main_form">
      <!--<div class="notif" hidden>
    <i class="uil uil-exclamation-triangle notify_icon"></i>
    <span class="notif_desc" >These details will be passed to airline</span>
  </div>-->
        <!--<div class="row d-flex justify-content-center">
      <div class="col-sm-3 custon_inputs">

        <input class="main_text-box" type="text" id="mobilenumber" [(ngModel)]="mobile" name="mobile">
        <label for="" class="input_lab_mobile required">Mobile</label>
        <span class="MsgMobileValidate" id="message"></span>

      </div>
      <div class="col-sm-3 custon_inputs">

        <input class="main_text-box" type="text" [(ngModel)]="phone" name="phone">
        <label for="" class="input_lab_phone required">Phone</label>
      </div>
      <div class="col-sm-3 custon_inputs">

        <input class="main_text-box text-lowercase" type="text" [(ngModel)]="email" name="email">
        <label for="" class="input_lab_e-mail required">E-mail</label>
      </div>
    </div>
  </div>-->
        @if (isCompanyDropdownShow) {
<div>
          <div class="main_form">

            <div class="cms_card-heading">Select Company</div>
            <div class="row justify-content-center">
              <div class="form-group">
                <p-select id="fromrtcc"
                            name="fromrt"
                            placeholder="Select Company"
                            [options]="GetAllUserBackCompanyCustomerCode"
                            optionLabel="companyName"
                            optionValue="userId"
                            [filter]="true"
                            filterBy="companyName"
                            required [(ngModel)]="selectedBackCompanyUserId" #fromrt="ngModel">
                          </p-select>
                          @if (fromrt.invalid && fromrt.touched) {
                            <div style="color:red">
                              Company is required
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                }

                <div class="main_form">
                  <div class="que_travel">Rules & Restrictions</div>
                  <div class="que_line"></div>
                  <div class="rules_headings"><i class="uil uil-circle rules_icon"></i>Kindely Check the spelling & reconfirm the passenger name(s) before you book.</div>
                  <div class="rules_headings"><i class="uil uil-circle rules_icon"></i>Ticket name changes are not permitted once issued.</div>
                  <h3 class="rules_desc">The above mentioned purchased tickets are non-transferable and name changes not permitted.</h3>
                  <div class="rules_footer">
                    <div class="checkBox">
                      <input type="checkbox" [(ngModel)]="agreed" [ngModelOptions]="{standalone: true}" (change)="active()" />
                      <div class="accept">I accept the Terms & Conditions.</div>
                    </div>
                    <!-- spinner -->
                    <!--<div class="psngr-save">
                    <div class="col-md-12 text-center">
                      <div class="spinner-border text-primary" ></div>
                    </div>
                  </div>-->
                  <div class="rules_buttons">
                    <p-dialog [(visible)]="visibleWrongAgency" [modal]="true" [closable]="false" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">

                      <p>
                        Fares has been Changed! Please search Again!.
                      </p>
                      <ng-template pTemplate="footer">
                        <button (click)="visibleWrongAgency =false" [routerLink]="['/flightSearch']" class="button-85">Back to Flight Search</button>
                      </ng-template>
                    </p-dialog>
                    <button class="sendButton" [disabled]="buttonagreed" (click)="tktSuccuessPopup(issueticket)">Continue</button>
                    <button class="cancelButton" (click)="cancel()">Cancel</button>
                    <div id="response-screen" style="margin-top:15px;text-align:center;font-size:1.2rem;font-weight:bold"></div>
                  </div>
                </div>
              </div>
            </form>


            <ng-template #mymodal let-modal>
              <div class="modal-header">
                <h4 class="modal-title" id="modal-basic-title">Flight Route</h4>
                <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                  <span aria-hidden="true" style="font-size:33px">&times;</span>
                </button>
              </div>
              <div class="modal-body">

                <div class="noti col-sm-12 notification_area">
                  @for (item of bookingBaseData.airSegment; track item; let i = $index) {
                    <div class="flight_details">
                      @if (item.layoverAvailable) {
                        <div class="flight_schedule flight_time_frame connectionTime">Connection Time: {{item.layoverTime}}</div>
                      }
                      <h4>{{item.origin.code}} To {{item.destination.code}}</h4>
                      <div class="flight_schedule">{{item.carrier}} <span class="dot">|</span> RBD: {{item.classOfService}}</div>
                      <div class="flight_screen">
                        <div class="flight_details_children flight_details_children_flex">
                          <img src="assets/img/take-off-24.png">
                          <div>
                            <div class="flight_schedule_larger"> {{item.departureDate}}-{{item.departureTime}} -  {{item.origin.code}}</div>
                            <div class="flight_schedule" style="white-space:pre-wrap">Terminal:{{item.origin.terminal}}</div>
                            <div class="flight_schedule" style="white-space:pre-wrap">{{item.origin.airportName}}</div>
                          </div>
                        </div>
                        <div class="flight_details_children flight_details_children_slide_left">
                          <div class="flight_schedule flight_time_frame">{{item.flightTime}}</div>
                          <div class="flight_schedule flight_time_frame">{{item.carrier}}  {{item.flightNumber}}</div>
                        </div>
                        <div class="flight_details_children flight_details_children_flex" style="padding-left:15px">
                          <img src="assets/img/landing-24.png" />
                          <div>
                            <div class="flight_schedule_larger"> {{item.arrivalDate}}-{{item.arrivalTime}} -  {{item.destination.code}}</div>
                            <div class="flight_schedule" style="white-space:pre-wrap">Terminal:{{item.destination.terminal}}</div>
                            <div class="flight_schedule" style="white-space:pre-wrap">{{item.destination.airportName}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>

              </div>
            </ng-template>
          </div>

        </div>
      </main>
